function PlanU({ ...props }) {
	return (
		<g id="plan-u">
			<g id="furniture">
				<polyline
					points="285.41 848.74 285.41 846.22 290.4 846.22 290.4 848.74 285.41 848.74"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="768.36"
					y1="434.12"
					x2="768.36"
					y2="545.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="660.54"
					y1="434.12"
					x2="768.36"
					y2="434.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="806.2"
					y1="449.78"
					x2="806.2"
					y2="443.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="806.2"
					y1="440.09"
					x2="806.2"
					y2="434.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="806.2"
					y1="430.4"
					x2="806.2"
					y2="424.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="806.2"
					y1="420.71"
					x2="806.2"
					y2="414.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="806.2"
					y1="411.03"
					x2="806.2"
					y2="404.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="806.2"
					y1="401.34"
					x2="806.2"
					y2="396.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="806.2"
					y1="396.28"
					x2="802.99"
					y2="396.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="799.36"
					y1="396.28"
					x2="793.3"
					y2="396.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="789.67"
					y1="396.28"
					x2="783.62"
					y2="396.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="779.98"
					y1="396.28"
					x2="773.93"
					y2="396.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="770.3"
					y1="396.28"
					x2="764.24"
					y2="396.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="760.61"
					y1="396.28"
					x2="754.56"
					y2="396.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="750.93"
					y1="396.28"
					x2="744.87"
					y2="396.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="741.24"
					y1="396.28"
					x2="735.19"
					y2="396.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="731.55"
					y1="396.28"
					x2="725.5"
					y2="396.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="721.87"
					y1="396.28"
					x2="715.81"
					y2="396.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="712.18"
					y1="396.28"
					x2="706.13"
					y2="396.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="702.5"
					y1="396.28"
					x2="696.44"
					y2="396.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="692.81"
					y1="396.28"
					x2="686.76"
					y2="396.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="660.54"
					y1="415.75"
					x2="660.54"
					y2="421.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="660.54"
					y1="425.44"
					x2="660.54"
					y2="431.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="660.54"
					y1="431.59"
					x2="665.47"
					y2="431.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="669.1"
					y1="431.59"
					x2="675.15"
					y2="431.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="678.78"
					y1="431.59"
					x2="684.84"
					y2="431.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="688.47"
					y1="431.59"
					x2="694.52"
					y2="431.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="698.16"
					y1="431.59"
					x2="704.21"
					y2="431.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="707.84"
					y1="431.59"
					x2="713.9"
					y2="431.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="717.53"
					y1="431.59"
					x2="723.58"
					y2="431.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="727.21"
					y1="431.59"
					x2="733.27"
					y2="431.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.9"
					y1="431.59"
					x2="742.95"
					y2="431.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="746.59"
					y1="431.59"
					x2="752.64"
					y2="431.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="756.27"
					y1="431.59"
					x2="762.33"
					y2="431.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="765.96"
					y1="431.59"
					x2="770.88"
					y2="431.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="770.88"
					y1="431.59"
					x2="770.88"
					y2="433.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="770.88"
					y1="437.16"
					x2="770.88"
					y2="443.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="770.88"
					y1="446.85"
					x2="770.88"
					y2="452.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="770.88"
					y1="456.54"
					x2="770.88"
					y2="462.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="770.88"
					y1="466.22"
					x2="770.88"
					y2="472.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="770.88"
					y1="475.91"
					x2="770.88"
					y2="481.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="770.88"
					y1="485.59"
					x2="770.88"
					y2="491.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="770.88"
					y1="495.28"
					x2="770.88"
					y2="501.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="770.88"
					y1="504.97"
					x2="770.88"
					y2="511.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="770.88"
					y1="514.65"
					x2="770.88"
					y2="520.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="770.88"
					y1="524.34"
					x2="770.88"
					y2="530.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="770.88"
					y1="534.02"
					x2="770.88"
					y2="540.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="770.88"
					y1="543.71"
					x2="770.88"
					y2="545.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="770.88"
					y1="545.65"
					x2="777.04"
					y2="545.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="780.67"
					y1="545.65"
					x2="786.73"
					y2="545.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="715.21 656.08 715.21 587.97 783.32 587.97 783.32 656.08 715.21 656.08"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="415.81 54.05 374.25 54.05 374.25 59.52 415.81 59.52 415.81 54.05"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="372.26 53.56 417.8 53.56 417.8 54.05 372.26 54.05 372.26 53.56"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="372.26"
					y1="53.56"
					x2="417.8"
					y2="53.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="417.8"
					y1="53.56"
					x2="417.8"
					y2="54.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="417.8"
					y1="54.05"
					x2="372.26"
					y2="54.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="372.26"
					y1="54.05"
					x2="372.26"
					y2="53.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="415.81"
					y1="59.52"
					x2="374.25"
					y2="59.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="374.25"
					y1="54.05"
					x2="415.81"
					y2="54.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="420.28 59.52 415.81 59.52 415.81 54.05 420.28 54.05 420.28 59.52"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="420.28"
					y1="59.52"
					x2="415.81"
					y2="59.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="415.81"
					y1="59.52"
					x2="415.81"
					y2="54.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="415.81"
					y1="54.05"
					x2="420.28"
					y2="54.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="420.28"
					y1="54.05"
					x2="420.28"
					y2="59.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="369.78 54.05 374.25 54.05 374.25 59.52 369.78 59.52 369.78 54.05"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="369.78"
					y1="54.05"
					x2="374.25"
					y2="54.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="374.25"
					y1="54.05"
					x2="374.25"
					y2="59.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="374.25"
					y1="59.52"
					x2="369.78"
					y2="59.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="369.78"
					y1="59.52"
					x2="369.78"
					y2="54.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="415.81"
					y1="55.05"
					x2="374.25"
					y2="55.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="422.27 59.02 420.28 59.02 420.28 54.05 417.8 54.05 417.8 53.56 422.27 53.56 422.27 59.02"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="422.27"
					y1="59.02"
					x2="420.28"
					y2="59.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="420.28"
					y1="59.02"
					x2="420.28"
					y2="54.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="420.28"
					y1="54.05"
					x2="417.8"
					y2="54.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="417.8"
					y1="54.05"
					x2="417.8"
					y2="53.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="417.8"
					y1="53.56"
					x2="422.27"
					y2="53.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="422.27"
					y1="53.56"
					x2="422.27"
					y2="59.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="367.79 53.56 372.26 53.56 372.26 54.05 369.78 54.05 369.78 59.02 367.79 59.02 367.79 53.56"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="367.79"
					y1="53.56"
					x2="372.26"
					y2="53.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="372.26"
					y1="53.56"
					x2="372.26"
					y2="54.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="372.26"
					y1="54.05"
					x2="369.78"
					y2="54.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="369.78"
					y1="54.05"
					x2="369.78"
					y2="59.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="369.78"
					y1="59.02"
					x2="367.79"
					y2="59.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="367.79"
					y1="59.02"
					x2="367.79"
					y2="53.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="365.27 55.05 365.27 57.57 262.11 57.57 262.11 55.05 365.27 55.05"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="365.27"
					y1="55.05"
					x2="365.27"
					y2="57.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="365.27"
					y1="57.57"
					x2="262.11"
					y2="57.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="262.11"
					y1="57.57"
					x2="262.11"
					y2="55.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="262.11"
					y1="55.05"
					x2="365.27"
					y2="55.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="422.27 55.05 427.31 55.05 427.31 70.18 422.27 70.18 422.27 55.05"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="427.31"
					y1="55.05"
					x2="422.27"
					y2="55.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="427.31"
					y1="70.18"
					x2="427.31"
					y2="55.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="422.27"
					y1="70.18"
					x2="427.31"
					y2="70.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="422.27"
					y1="55.05"
					x2="422.27"
					y2="70.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="362.75 55.05 367.79 55.05 367.79 70.18 362.75 70.18 362.75 55.05"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="367.79"
					y1="55.05"
					x2="362.75"
					y2="55.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="367.79"
					y1="70.18"
					x2="367.79"
					y2="55.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="362.75"
					y1="70.18"
					x2="367.79"
					y2="70.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="362.75"
					y1="55.05"
					x2="362.75"
					y2="70.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="259.59 55.05 264.63 55.05 264.63 70.18 259.59 70.18 259.59 55.05"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="264.63"
					y1="55.05"
					x2="259.59"
					y2="55.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="264.63"
					y1="70.18"
					x2="264.63"
					y2="55.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="259.59"
					y1="70.18"
					x2="264.63"
					y2="70.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="259.59"
					y1="55.05"
					x2="259.59"
					y2="70.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="752.43 54.05 710.86 54.05 710.86 59.52 752.43 59.52 752.43 54.05"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="708.88 53.56 754.41 53.56 754.41 54.05 708.88 54.05 708.88 53.56"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="708.88"
					y1="53.56"
					x2="754.41"
					y2="53.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="754.41"
					y1="53.56"
					x2="754.41"
					y2="54.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="754.41"
					y1="54.05"
					x2="708.88"
					y2="54.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="708.88"
					y1="54.05"
					x2="708.88"
					y2="53.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.43"
					y1="59.52"
					x2="710.86"
					y2="59.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="710.86"
					y1="54.05"
					x2="752.43"
					y2="54.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="756.9 59.52 752.43 59.52 752.43 54.05 756.9 54.05 756.9 59.52"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="756.9"
					y1="59.52"
					x2="752.43"
					y2="59.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.43"
					y1="59.52"
					x2="752.43"
					y2="54.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.43"
					y1="54.05"
					x2="756.9"
					y2="54.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="756.9"
					y1="54.05"
					x2="756.9"
					y2="59.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="706.39 54.05 710.86 54.05 710.86 59.52 706.39 59.52 706.39 54.05"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="706.39"
					y1="54.05"
					x2="710.86"
					y2="54.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="710.86"
					y1="54.05"
					x2="710.86"
					y2="59.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="710.86"
					y1="59.52"
					x2="706.39"
					y2="59.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="706.39"
					y1="59.52"
					x2="706.39"
					y2="54.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.43"
					y1="55.05"
					x2="710.86"
					y2="55.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="758.88 59.02 756.9 59.02 756.9 54.05 754.41 54.05 754.41 53.56 758.88 53.56 758.88 59.02"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="758.88"
					y1="59.02"
					x2="756.9"
					y2="59.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="756.9"
					y1="59.02"
					x2="756.9"
					y2="54.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="756.9"
					y1="54.05"
					x2="754.41"
					y2="54.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="754.41"
					y1="54.05"
					x2="754.41"
					y2="53.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="754.41"
					y1="53.56"
					x2="758.88"
					y2="53.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="758.88"
					y1="53.56"
					x2="758.88"
					y2="59.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="704.41 53.56 708.88 53.56 708.88 54.05 706.39 54.05 706.39 59.02 704.41 59.02 704.41 53.56"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="704.41"
					y1="53.56"
					x2="708.88"
					y2="53.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="708.88"
					y1="53.56"
					x2="708.88"
					y2="54.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="708.88"
					y1="54.05"
					x2="706.39"
					y2="54.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="706.39"
					y1="54.05"
					x2="706.39"
					y2="59.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="706.39"
					y1="59.02"
					x2="704.41"
					y2="59.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="704.41"
					y1="59.02"
					x2="704.41"
					y2="53.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="701.89 55.05 701.89 57.57 568.64 57.57 568.64 55.05 701.89 55.05"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="701.89"
					y1="55.05"
					x2="701.89"
					y2="57.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="701.89"
					y1="57.57"
					x2="568.64"
					y2="57.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="568.64"
					y1="57.57"
					x2="568.64"
					y2="55.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="568.64"
					y1="55.05"
					x2="701.89"
					y2="55.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="758.88 55.05 763.93 55.05 763.93 70.18 758.88 70.18 758.88 55.05"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="763.93"
					y1="55.05"
					x2="758.88"
					y2="55.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="763.93"
					y1="70.18"
					x2="763.93"
					y2="55.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="758.88"
					y1="70.18"
					x2="763.93"
					y2="70.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="758.88"
					y1="55.05"
					x2="758.88"
					y2="70.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="699.36 55.05 704.41 55.05 704.41 70.18 699.36 70.18 699.36 55.05"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="704.41"
					y1="55.05"
					x2="699.36"
					y2="55.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="704.41"
					y1="70.18"
					x2="704.41"
					y2="55.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="699.36"
					y1="70.18"
					x2="704.41"
					y2="70.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="699.36"
					y1="55.05"
					x2="699.36"
					y2="70.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="566.12 55.05 571.16 55.05 571.16 70.18 566.12 70.18 566.12 55.05"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="571.16"
					y1="55.05"
					x2="566.12"
					y2="55.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="571.16"
					y1="70.18"
					x2="571.16"
					y2="55.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="566.12"
					y1="70.18"
					x2="571.16"
					y2="70.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="566.12"
					y1="55.05"
					x2="566.12"
					y2="70.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="605.42"
					y1="948.74"
					x2="609.21"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="605.42"
					y1="928.56"
					x2="609.21"
					y2="928.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="605.42"
					y1="928.56"
					x2="605.42"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="509.57"
					y1="948.74"
					x2="505.79"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="509.57"
					y1="928.56"
					x2="505.79"
					y2="928.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="509.57"
					y1="928.56"
					x2="509.57"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<polyline
					points="510.83 950 510.83 948.74 505.79 948.74 505.79 950 510.83 950"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="604.16 948.74 604.16 950 609.21 950 609.21 948.74 604.16 948.74"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="510.83 928.56 510.83 927.29 505.79 927.29 505.79 928.56 510.83 928.56"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="604.16 927.29 604.16 928.56 609.21 928.56 609.21 927.29 604.16 927.29"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="510.83"
					y1="950"
					x2="505.79"
					y2="950"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="505.79"
					y1="950"
					x2="505.79"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="505.79"
					y1="948.74"
					x2="510.83"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="510.83"
					y1="948.74"
					x2="510.83"
					y2="950"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="604.16"
					y1="948.74"
					x2="609.21"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="609.21"
					y1="948.74"
					x2="609.21"
					y2="950"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="609.21"
					y1="950"
					x2="604.16"
					y2="950"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="604.16"
					y1="950"
					x2="604.16"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="510.83"
					y1="928.56"
					x2="505.79"
					y2="928.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="505.79"
					y1="928.56"
					x2="505.79"
					y2="927.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="505.79"
					y1="927.29"
					x2="510.83"
					y2="927.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="510.83"
					y1="927.29"
					x2="510.83"
					y2="928.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="604.16"
					y1="927.29"
					x2="609.21"
					y2="927.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="609.21"
					y1="927.29"
					x2="609.21"
					y2="928.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="609.21"
					y1="928.56"
					x2="604.16"
					y2="928.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="604.16"
					y1="928.56"
					x2="604.16"
					y2="927.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="512.09 948.74 512.09 928.56 510.2 928.56 510.2 948.74 512.09 948.74"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="604.79 948.74 604.79 928.56 602.9 928.56 602.9 948.74 604.79 948.74"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="538.69 864.34 535.57 867.47 599.78 931.68 602.9 928.56 538.69 864.34"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="510.2"
					y1="928.56"
					x2="509.57"
					y2="928.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="510.2"
					y1="948.74"
					x2="509.57"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="509.57"
					y1="928.56"
					x2="509.57"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="604.79"
					y1="928.56"
					x2="605.42"
					y2="928.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="604.79"
					y1="948.74"
					x2="605.42"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="605.42"
					y1="928.56"
					x2="605.42"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="512.09"
					y1="948.74"
					x2="512.09"
					y2="928.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="512.09"
					y1="928.56"
					x2="510.2"
					y2="928.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="510.2"
					y1="928.56"
					x2="510.2"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="510.2"
					y1="948.74"
					x2="512.09"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="604.79"
					y1="948.74"
					x2="604.79"
					y2="928.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="604.79"
					y1="928.56"
					x2="602.9"
					y2="928.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="602.9"
					y1="928.56"
					x2="602.9"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="602.9"
					y1="948.74"
					x2="604.79"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="538.69"
					y1="864.34"
					x2="535.57"
					y2="867.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="535.57"
					y1="867.47"
					x2="599.78"
					y2="931.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="599.78"
					y1="931.68"
					x2="602.9"
					y2="928.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="602.9"
					y1="928.56"
					x2="538.69"
					y2="864.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="509.57"
					y1="928.56"
					x2="509.57"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="509.57"
					y1="928.56"
					x2="509.57"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="509.57"
					y1="928.56"
					x2="505.79"
					y2="928.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="509.57"
					y1="928.56"
					x2="505.79"
					y2="928.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="509.57"
					y1="948.74"
					x2="505.79"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="509.57"
					y1="948.74"
					x2="505.79"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="605.42"
					y1="928.56"
					x2="605.42"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="605.42"
					y1="928.56"
					x2="605.42"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="605.42"
					y1="928.56"
					x2="609.21"
					y2="928.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="605.42"
					y1="928.56"
					x2="609.21"
					y2="928.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="605.42"
					y1="948.74"
					x2="609.21"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="605.42"
					y1="948.74"
					x2="609.21"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="193.8"
					y1="928.56"
					x2="193.8"
					y2="843.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="193.8"
					y1="843.7"
					x2="216.91"
					y2="843.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="216.91"
					y1="843.7"
					x2="216.91"
					y2="823.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="216.91"
					y1="823.52"
					x2="216.91"
					y2="558.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="259.59"
					y1="50"
					x2="259.59"
					y2="70.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="784.47"
					y1="602.32"
					x2="784.47"
					y2="622.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="777.97"
					y1="696.57"
					x2="777.97"
					y2="770.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="777.97"
					y1="770.74"
					x2="795.65"
					y2="770.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="519.79"
					y1="558.26"
					x2="516"
					y2="558.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="519.79"
					y1="545.65"
					x2="516"
					y2="545.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="519.79"
					y1="545.65"
					x2="519.79"
					y2="558.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="600.51"
					y1="558.26"
					x2="604.29"
					y2="558.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="600.51"
					y1="545.65"
					x2="604.29"
					y2="545.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="600.51"
					y1="545.65"
					x2="600.51"
					y2="558.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="478.08"
					y1="545.65"
					x2="478.08"
					y2="558.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="397.36"
					y1="558.26"
					x2="393.58"
					y2="558.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="397.36"
					y1="545.65"
					x2="393.58"
					y2="545.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="397.36"
					y1="545.65"
					x2="397.36"
					y2="558.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<polyline
					points="599.25 559.52 604.29 559.52 604.29 558.26 599.25 558.26 599.25 559.52"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="521.05 558.26 516 558.26 516 559.52 521.05 559.52 521.05 558.26"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="599.25 545.65 604.29 545.65 604.29 544.38 599.25 544.38 599.25 545.65"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="521.05 544.38 516 544.38 516 545.65 521.05 545.65 521.05 544.38"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="599.25"
					y1="559.52"
					x2="604.29"
					y2="559.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="604.29"
					y1="559.52"
					x2="604.29"
					y2="558.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="604.29"
					y1="558.26"
					x2="599.25"
					y2="558.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="599.25"
					y1="558.26"
					x2="599.25"
					y2="559.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="521.05"
					y1="558.26"
					x2="516"
					y2="558.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="516"
					y1="558.26"
					x2="516"
					y2="559.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="516"
					y1="559.52"
					x2="521.05"
					y2="559.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="521.05"
					y1="559.52"
					x2="521.05"
					y2="558.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="599.25"
					y1="545.65"
					x2="604.29"
					y2="545.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="604.29"
					y1="545.65"
					x2="604.29"
					y2="544.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="604.29"
					y1="544.38"
					x2="599.25"
					y2="544.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="599.25"
					y1="544.38"
					x2="599.25"
					y2="545.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="521.05"
					y1="544.38"
					x2="516"
					y2="544.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="516"
					y1="544.38"
					x2="516"
					y2="545.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="516"
					y1="545.65"
					x2="521.05"
					y2="545.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="521.05"
					y1="545.65"
					x2="521.05"
					y2="544.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="597.99 558.26 599.88 558.26 599.88 545.65 597.99 545.65 597.99 558.26"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="520.42 558.26 522.31 558.26 522.31 545.65 520.42 545.65 520.42 558.26"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="575.82 492.14 522.31 545.65 525.43 548.77 578.94 495.26 575.82 492.14"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="599.88"
					y1="545.65"
					x2="600.51"
					y2="545.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="599.88"
					y1="558.26"
					x2="600.51"
					y2="558.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="600.51"
					y1="545.65"
					x2="600.51"
					y2="558.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="520.42"
					y1="545.65"
					x2="519.79"
					y2="545.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="520.42"
					y1="558.26"
					x2="519.79"
					y2="558.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="519.79"
					y1="545.65"
					x2="519.79"
					y2="558.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="597.98"
					y1="558.26"
					x2="597.98"
					y2="545.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="597.98"
					y1="545.65"
					x2="599.88"
					y2="545.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="599.88"
					y1="545.65"
					x2="599.88"
					y2="558.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="599.88"
					y1="558.26"
					x2="597.98"
					y2="558.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="520.42"
					y1="558.26"
					x2="520.42"
					y2="545.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="520.42"
					y1="545.65"
					x2="522.31"
					y2="545.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="522.31"
					y1="545.65"
					x2="522.31"
					y2="558.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="522.31"
					y1="558.26"
					x2="520.42"
					y2="558.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="575.82"
					y1="492.14"
					x2="578.94"
					y2="495.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="578.94"
					y1="495.26"
					x2="525.43"
					y2="548.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="525.43"
					y1="548.77"
					x2="522.31"
					y2="545.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="522.31"
					y1="545.65"
					x2="575.82"
					y2="492.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="600.51"
					y1="545.65"
					x2="600.51"
					y2="558.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="600.51"
					y1="545.65"
					x2="600.51"
					y2="558.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="600.51"
					y1="545.65"
					x2="604.29"
					y2="545.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="600.51"
					y1="545.65"
					x2="604.29"
					y2="545.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="600.51"
					y1="558.26"
					x2="604.29"
					y2="558.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="600.51"
					y1="558.26"
					x2="604.29"
					y2="558.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="519.79"
					y1="545.65"
					x2="519.79"
					y2="558.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="519.79"
					y1="545.65"
					x2="519.79"
					y2="558.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="519.79"
					y1="545.65"
					x2="516"
					y2="545.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="519.79"
					y1="545.65"
					x2="516"
					y2="545.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="519.79"
					y1="558.26"
					x2="516"
					y2="558.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="519.79"
					y1="558.26"
					x2="516"
					y2="558.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<polyline
					points="398.62 559.52 398.62 558.26 393.58 558.26 393.58 559.52 398.62 559.52"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="398.62 545.65 398.62 544.38 393.58 544.38 393.58 545.65 398.62 545.65"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="398.62"
					y1="559.52"
					x2="393.58"
					y2="559.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="393.58"
					y1="559.52"
					x2="393.58"
					y2="558.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="393.58"
					y1="558.26"
					x2="398.62"
					y2="558.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="398.62"
					y1="558.26"
					x2="398.62"
					y2="559.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="476.82"
					y1="559.52"
					x2="476.82"
					y2="558.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="398.62"
					y1="545.65"
					x2="393.58"
					y2="545.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="393.58"
					y1="545.65"
					x2="393.58"
					y2="544.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="393.58"
					y1="544.38"
					x2="398.62"
					y2="544.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="398.62"
					y1="544.38"
					x2="398.62"
					y2="545.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="476.82"
					y1="545.65"
					x2="476.82"
					y2="544.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="399.88 558.26 399.88 545.65 397.99 545.65 397.99 558.26 399.88 558.26"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="477.45 558.26 477.45 545.65 475.55 545.65 475.55 558.26 477.45 558.26"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="422.04 492.14 418.92 495.26 472.44 548.77 475.55 545.65 422.04 492.14"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="397.99"
					y1="545.65"
					x2="397.36"
					y2="545.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="397.99"
					y1="558.26"
					x2="397.36"
					y2="558.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="397.36"
					y1="545.65"
					x2="397.36"
					y2="558.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="477.45"
					y1="545.65"
					x2="478.08"
					y2="545.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="477.45"
					y1="558.26"
					x2="478.08"
					y2="558.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="478.08"
					y1="545.65"
					x2="478.08"
					y2="558.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="399.88"
					y1="558.26"
					x2="399.88"
					y2="545.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="399.88"
					y1="545.65"
					x2="397.99"
					y2="545.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="397.99"
					y1="545.65"
					x2="397.99"
					y2="558.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="397.99"
					y1="558.26"
					x2="399.88"
					y2="558.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="477.45"
					y1="558.26"
					x2="477.45"
					y2="545.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="477.45"
					y1="545.65"
					x2="475.55"
					y2="545.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="475.55"
					y1="545.65"
					x2="475.55"
					y2="558.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="475.55"
					y1="558.26"
					x2="477.45"
					y2="558.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="422.04"
					y1="492.14"
					x2="418.92"
					y2="495.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="418.92"
					y1="495.26"
					x2="472.44"
					y2="548.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="472.44"
					y1="548.77"
					x2="475.55"
					y2="545.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="475.55"
					y1="545.65"
					x2="422.04"
					y2="492.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="397.36"
					y1="545.65"
					x2="397.36"
					y2="558.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="397.36"
					y1="545.65"
					x2="397.36"
					y2="558.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="397.36"
					y1="545.65"
					x2="393.58"
					y2="545.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="397.36"
					y1="545.65"
					x2="393.58"
					y2="545.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="397.36"
					y1="558.26"
					x2="393.58"
					y2="558.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="397.36"
					y1="558.26"
					x2="393.58"
					y2="558.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="478.08"
					y1="545.65"
					x2="478.08"
					y2="558.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="478.08"
					y1="545.65"
					x2="478.08"
					y2="558.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="700.45"
					y1="587.76"
					x2="700.45"
					y2="583.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="713.06"
					y1="587.76"
					x2="713.06"
					y2="583.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="713.06"
					y1="587.76"
					x2="700.45"
					y2="587.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="700.45"
					y1="658.38"
					x2="700.45"
					y2="662.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="713.06"
					y1="658.38"
					x2="713.06"
					y2="662.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="713.06"
					y1="658.38"
					x2="700.45"
					y2="658.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="713.06"
					y1="587.76"
					x2="713.06"
					y2="582.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<polyline
					points="699.19 657.12 699.19 662.17 700.45 662.17 700.45 657.12 699.19 657.12"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="700.45 589.02 700.45 583.97 699.19 583.97 699.19 589.02 700.45 589.02"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="713.06 657.12 713.06 662.17 714.32 662.17 714.32 657.12 713.06 657.12"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="714.32 589.02 714.32 583.97 713.06 583.97 713.06 589.02 714.32 589.02"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="699.19"
					y1="657.12"
					x2="699.19"
					y2="662.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="699.19"
					y1="662.17"
					x2="700.45"
					y2="662.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="700.45"
					y1="662.17"
					x2="700.45"
					y2="657.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="700.45"
					y1="657.12"
					x2="699.19"
					y2="657.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="700.45"
					y1="589.02"
					x2="700.45"
					y2="583.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="700.45"
					y1="583.97"
					x2="699.19"
					y2="583.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="699.19"
					y1="583.97"
					x2="699.19"
					y2="589.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="699.19"
					y1="589.02"
					x2="700.45"
					y2="589.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="713.06"
					y1="657.12"
					x2="713.06"
					y2="662.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="713.06"
					y1="662.17"
					x2="714.32"
					y2="662.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="714.32"
					y1="662.17"
					x2="714.32"
					y2="657.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="714.32"
					y1="657.12"
					x2="713.06"
					y2="657.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="714.32"
					y1="589.02"
					x2="714.32"
					y2="583.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="714.32"
					y1="583.97"
					x2="713.06"
					y2="583.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="713.06"
					y1="583.97"
					x2="713.06"
					y2="589.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="713.06"
					y1="589.02"
					x2="714.32"
					y2="589.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="713.06 655.86 700.45 655.86 700.45 657.75 713.06 657.75 713.06 655.86"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="713.06 588.38 700.45 588.38 700.45 590.28 713.06 590.28 713.06 588.38"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="654.08 636.65 657.2 639.77 703.57 593.4 700.45 590.28 654.08 636.65"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="700.45"
					y1="657.75"
					x2="700.45"
					y2="658.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="713.06"
					y1="657.75"
					x2="713.06"
					y2="658.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="700.45"
					y1="658.38"
					x2="713.06"
					y2="658.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="700.45"
					y1="588.38"
					x2="700.45"
					y2="587.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="713.06"
					y1="588.38"
					x2="713.06"
					y2="587.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="700.45"
					y1="587.76"
					x2="713.06"
					y2="587.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="713.06"
					y1="655.86"
					x2="700.45"
					y2="655.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="700.45"
					y1="655.86"
					x2="700.45"
					y2="657.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="700.45"
					y1="657.75"
					x2="713.06"
					y2="657.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="713.06"
					y1="657.75"
					x2="713.06"
					y2="655.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="713.06"
					y1="588.38"
					x2="700.45"
					y2="588.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="700.45"
					y1="588.38"
					x2="700.45"
					y2="590.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="700.45"
					y1="590.28"
					x2="713.06"
					y2="590.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="713.06"
					y1="590.28"
					x2="713.06"
					y2="588.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="654.08"
					y1="636.65"
					x2="657.2"
					y2="639.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="657.2"
					y1="639.77"
					x2="703.57"
					y2="593.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="703.57"
					y1="593.4"
					x2="700.45"
					y2="590.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="700.45"
					y1="590.28"
					x2="654.08"
					y2="636.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="713.06"
					y1="658.38"
					x2="700.45"
					y2="658.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="713.06"
					y1="658.38"
					x2="700.45"
					y2="658.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="713.06"
					y1="658.38"
					x2="713.06"
					y2="662.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="713.06"
					y1="658.38"
					x2="713.06"
					y2="662.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="700.45"
					y1="658.38"
					x2="700.45"
					y2="662.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="700.45"
					y1="658.38"
					x2="700.45"
					y2="662.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="713.06"
					y1="587.76"
					x2="700.45"
					y2="587.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="713.06"
					y1="587.76"
					x2="700.45"
					y2="587.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="713.06"
					y1="587.76"
					x2="713.06"
					y2="583.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="713.06"
					y1="587.76"
					x2="713.06"
					y2="583.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="700.45"
					y1="587.76"
					x2="700.45"
					y2="583.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="700.45"
					y1="587.76"
					x2="700.45"
					y2="583.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="610.95"
					y1="913.54"
					x2="610.95"
					y2="917.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="623.56"
					y1="913.54"
					x2="623.56"
					y2="917.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="623.56"
					y1="913.54"
					x2="610.95"
					y2="913.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="610.95"
					y1="832.83"
					x2="610.95"
					y2="829.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="623.56"
					y1="832.83"
					x2="623.56"
					y2="829.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="623.56"
					y1="832.83"
					x2="610.95"
					y2="832.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<polyline
					points="609.69 834.09 610.95 834.09 610.95 829.04 609.69 829.04 609.69 834.09"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="610.95 912.28 609.69 912.28 609.69 917.33 610.95 917.33 610.95 912.28"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="623.56 834.09 624.82 834.09 624.82 829.04 623.56 829.04 623.56 834.09"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="624.82 912.28 623.56 912.28 623.56 917.33 624.82 917.33 624.82 912.28"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="609.69"
					y1="834.09"
					x2="609.69"
					y2="829.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="609.69"
					y1="829.04"
					x2="610.95"
					y2="829.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="610.95"
					y1="829.04"
					x2="610.95"
					y2="834.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="610.95"
					y1="834.09"
					x2="609.69"
					y2="834.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="610.95"
					y1="912.28"
					x2="610.95"
					y2="917.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="610.95"
					y1="917.33"
					x2="609.69"
					y2="917.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="609.69"
					y1="917.33"
					x2="609.69"
					y2="912.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="609.69"
					y1="912.28"
					x2="610.95"
					y2="912.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="623.56"
					y1="834.09"
					x2="623.56"
					y2="829.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="623.56"
					y1="829.04"
					x2="624.82"
					y2="829.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="624.82"
					y1="829.04"
					x2="624.82"
					y2="834.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="624.82"
					y1="834.09"
					x2="623.56"
					y2="834.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="624.82"
					y1="912.28"
					x2="624.82"
					y2="917.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="624.82"
					y1="917.33"
					x2="623.56"
					y2="917.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="623.56"
					y1="917.33"
					x2="623.56"
					y2="912.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="623.56"
					y1="912.28"
					x2="624.82"
					y2="912.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="610.95 835.35 623.56 835.35 623.56 833.46 610.95 833.46 610.95 835.35"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="610.95 912.91 623.56 912.91 623.56 911.02 610.95 911.02 610.95 912.91"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="677.07 857.51 673.95 854.39 620.44 907.9 623.56 911.02 677.07 857.51"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="623.56"
					y1="833.46"
					x2="623.56"
					y2="832.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="610.95"
					y1="833.46"
					x2="610.95"
					y2="832.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="623.56"
					y1="832.83"
					x2="610.95"
					y2="832.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="623.56"
					y1="912.91"
					x2="623.56"
					y2="913.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="610.95"
					y1="912.91"
					x2="610.95"
					y2="913.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="623.56"
					y1="913.54"
					x2="610.95"
					y2="913.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="610.95"
					y1="835.35"
					x2="623.56"
					y2="835.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="623.56"
					y1="835.35"
					x2="623.56"
					y2="833.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="623.56"
					y1="833.46"
					x2="610.95"
					y2="833.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="610.95"
					y1="833.46"
					x2="610.95"
					y2="835.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="610.95"
					y1="912.91"
					x2="623.56"
					y2="912.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="623.56"
					y1="912.91"
					x2="623.56"
					y2="911.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="623.56"
					y1="911.02"
					x2="610.95"
					y2="911.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="610.95"
					y1="911.02"
					x2="610.95"
					y2="912.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="677.07"
					y1="857.51"
					x2="673.95"
					y2="854.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="673.95"
					y1="854.39"
					x2="620.44"
					y2="907.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="620.44"
					y1="907.9"
					x2="623.56"
					y2="911.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="623.56"
					y1="911.02"
					x2="677.07"
					y2="857.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="623.56"
					y1="832.83"
					x2="610.95"
					y2="832.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="623.56"
					y1="832.83"
					x2="610.95"
					y2="832.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="623.56"
					y1="832.83"
					x2="623.56"
					y2="829.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="623.56"
					y1="832.83"
					x2="623.56"
					y2="829.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="610.95"
					y1="832.83"
					x2="610.95"
					y2="829.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="610.95"
					y1="832.83"
					x2="610.95"
					y2="829.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="623.56"
					y1="913.54"
					x2="610.95"
					y2="913.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="623.56"
					y1="913.54"
					x2="610.95"
					y2="913.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="623.56"
					y1="913.54"
					x2="623.56"
					y2="917.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="623.56"
					y1="913.54"
					x2="623.56"
					y2="917.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="610.95"
					y1="913.54"
					x2="610.95"
					y2="917.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="610.95"
					y1="913.54"
					x2="610.95"
					y2="917.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="623.56"
					y1="696.57"
					x2="777.97"
					y2="696.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="660.54"
					y1="536.3"
					x2="647.93"
					y2="536.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="647.93"
					y1="465.68"
					x2="647.93"
					y2="461.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="660.54"
					y1="465.68"
					x2="660.54"
					y2="461.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="660.54"
					y1="465.68"
					x2="647.93"
					y2="465.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<polyline
					points="646.67 466.94 647.93 466.94 647.93 461.89 646.67 461.89 646.67 466.94"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="660.54 466.94 661.8 466.94 661.8 461.89 660.54 461.89 660.54 466.94"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="646.67"
					y1="466.94"
					x2="646.67"
					y2="461.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="646.67"
					y1="461.89"
					x2="647.93"
					y2="461.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="647.93"
					y1="461.89"
					x2="647.93"
					y2="466.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="647.93"
					y1="466.94"
					x2="646.67"
					y2="466.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="646.67"
					y1="535.04"
					x2="647.93"
					y2="535.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="660.54"
					y1="466.94"
					x2="660.54"
					y2="461.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="660.54"
					y1="461.89"
					x2="661.8"
					y2="461.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="661.8"
					y1="461.89"
					x2="661.8"
					y2="466.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="661.8"
					y1="466.94"
					x2="660.54"
					y2="466.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="660.54"
					y1="535.04"
					x2="661.8"
					y2="535.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="647.93 468.2 660.54 468.2 660.54 466.31 647.93 466.31 647.93 468.2"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="647.93 535.68 660.54 535.68 660.54 533.78 647.93 533.78 647.93 535.68"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="706.92 487.41 703.79 484.29 657.42 530.66 660.54 533.78 706.92 487.41"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="660.54"
					y1="466.31"
					x2="660.54"
					y2="465.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="647.93"
					y1="466.31"
					x2="647.93"
					y2="465.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="660.54"
					y1="465.68"
					x2="647.93"
					y2="465.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="660.54"
					y1="535.68"
					x2="660.54"
					y2="536.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="647.93"
					y1="535.68"
					x2="647.93"
					y2="536.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="660.54"
					y1="536.3"
					x2="647.93"
					y2="536.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="647.93"
					y1="468.2"
					x2="660.54"
					y2="468.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="660.54"
					y1="468.2"
					x2="660.54"
					y2="466.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="660.54"
					y1="466.31"
					x2="647.93"
					y2="466.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="647.93"
					y1="466.31"
					x2="647.93"
					y2="468.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="647.93"
					y1="535.68"
					x2="660.54"
					y2="535.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="660.54"
					y1="535.68"
					x2="660.54"
					y2="533.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="660.54"
					y1="533.78"
					x2="647.93"
					y2="533.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="647.93"
					y1="533.78"
					x2="647.93"
					y2="535.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="706.92"
					y1="487.41"
					x2="703.79"
					y2="484.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="703.79"
					y1="484.29"
					x2="657.42"
					y2="530.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="657.42"
					y1="530.66"
					x2="660.54"
					y2="533.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="660.54"
					y1="533.78"
					x2="706.92"
					y2="487.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="660.54"
					y1="465.68"
					x2="647.93"
					y2="465.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="660.54"
					y1="465.68"
					x2="647.93"
					y2="465.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="660.54"
					y1="465.68"
					x2="660.54"
					y2="461.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="660.54"
					y1="465.68"
					x2="660.54"
					y2="461.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="647.93"
					y1="465.68"
					x2="647.93"
					y2="461.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="647.93"
					y1="465.68"
					x2="647.93"
					y2="461.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="660.54"
					y1="536.3"
					x2="647.93"
					y2="536.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="660.54"
					y1="536.3"
					x2="647.93"
					y2="536.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="763.93"
					y1="50"
					x2="763.93"
					y2="70.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="566.12"
					y1="70.18"
					x2="566.12"
					y2="50"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="566.12"
					y1="50"
					x2="427.31"
					y2="50"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="427.31"
					y1="50"
					x2="427.31"
					y2="70.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<polyline
					points="729.41 875.32 727.4 879.82 726.7 884.7 727.4 889.58 729.41 894.08 731.96 897.05 735.15 899.3 738.82 900.97 742.66 902.16 748.9 903.16 755.2 902.79 761.27 901.04 766.82 901.19 772.19 902.59 777.1 905.19 779.24 906.54 782.09 907.81 785.18 908.27 788.28 907.9 790.12 907.18 795.02 907.18 795.02 905.13 792.78 905.13 794.85 901.72 795.65 897.8 795.65 871.6 794.86 867.73 792.72 864.41 789.52 862.09 785.7 861.1 785.09 861.1 781.94 861.62 776.98 864.28 772.13 866.85 766.82 868.25 761.33 868.39 755.25 866.63 748.92 866.24 742.66 867.25 738.82 868.44 735.15 870.1 731.96 872.35 729.41 875.32"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="772.36"
					y1="894.04"
					x2="772.36"
					y2="875.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="795.65"
					y1="871.6"
					x2="795.65"
					y2="884.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="794.71"
					y1="871.6"
					x2="794.71"
					y2="884.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="795.65"
					y1="897.8"
					x2="795.65"
					y2="884.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="794.71"
					y1="897.8"
					x2="794.71"
					y2="884.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="772.36"
					y1="875.85"
					x2="775.85"
					y2="875.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="775.85"
					y1="875.85"
					x2="775.85"
					y2="878.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="775.85"
					y1="878.73"
					x2="772.36"
					y2="878.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="772.36"
					y1="893.55"
					x2="775.85"
					y2="893.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="775.85"
					y1="893.55"
					x2="775.85"
					y2="890.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="775.85"
					y1="890.67"
					x2="772.36"
					y2="890.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="786.34"
					y1="905.13"
					x2="795.02"
					y2="905.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="786.34"
					y1="907.18"
					x2="795.02"
					y2="907.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="795.02"
					y1="907.18"
					x2="795.02"
					y2="905.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="786.34"
					y1="907.18"
					x2="786.34"
					y2="905.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="726.7"
					y1="884.7"
					x2="727.06"
					y2="881.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="727.06"
					y1="881.57"
					x2="727.87"
					y2="878.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="727.87"
					y1="878.54"
					x2="729.41"
					y2="875.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="729.41"
					y1="875.32"
					x2="731.96"
					y2="872.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="731.96"
					y1="872.35"
					x2="735.15"
					y2="870.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="735.15"
					y1="870.1"
					x2="738.8"
					y2="868.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="738.8"
					y1="868.45"
					x2="742.66"
					y2="867.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="742.66"
					y1="867.25"
					x2="748.91"
					y2="866.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="748.91"
					y1="866.16"
					x2="752.06"
					y2="866.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.06"
					y1="866.1"
					x2="755.2"
					y2="866.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="755.2"
					y1="866.45"
					x2="760.07"
					y2="867.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="760.07"
					y1="867.87"
					x2="764.78"
					y2="870.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="764.78"
					y1="870.08"
					x2="768.99"
					y2="872.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="768.99"
					y1="872.7"
					x2="772.36"
					y2="875.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="761.33"
					y1="868.39"
					x2="765.71"
					y2="868.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="765.71"
					y1="868.36"
					x2="769.96"
					y2="867.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="769.96"
					y1="867.64"
					x2="772.25"
					y2="866.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="772.25"
					y1="866.9"
					x2="774.52"
					y2="865.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="774.52"
					y1="865.83"
					x2="777.83"
					y2="863.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="777.83"
					y1="863.72"
					x2="781.25"
					y2="861.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="781.25"
					y1="861.87"
					x2="784.58"
					y2="861.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="784.58"
					y1="861.12"
					x2="787.91"
					y2="861.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="787.91"
					y1="861.41"
					x2="790.94"
					y2="862.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="790.94"
					y1="862.7"
					x2="792.25"
					y2="863.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="792.25"
					y1="863.72"
					x2="793.37"
					y2="864.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="793.37"
					y1="864.99"
					x2="794.61"
					y2="867.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="794.61"
					y1="867.23"
					x2="795.3"
					y2="869.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="795.3"
					y1="869.36"
					x2="795.65"
					y2="871.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="794.71"
					y1="871.6"
					x2="794.61"
					y2="870.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="794.61"
					y1="870.6"
					x2="793.97"
					y2="868.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="793.97"
					y1="868.54"
					x2="792.44"
					y2="866.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="792.44"
					y1="866.72"
					x2="790.31"
					y2="865.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="790.31"
					y1="865.58"
					x2="787.49"
					y2="865.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="787.49"
					y1="865.04"
					x2="784.59"
					y2="864.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="784.59"
					y1="864.91"
					x2="783.15"
					y2="864.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="783.15"
					y1="864.93"
					x2="782.01"
					y2="865.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="782.01"
					y1="865.54"
					x2="781.68"
					y2="866.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="781.68"
					y1="866.25"
					x2="779.42"
					y2="874.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="779.42"
					y1="874.17"
					x2="778.75"
					y2="878.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="778.75"
					y1="878.11"
					x2="778.46"
					y2="882.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="778.46"
					y1="882.1"
					x2="778.46"
					y2="884.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="761.27"
					y1="901.04"
					x2="765.65"
					y2="901.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="765.65"
					y1="901.07"
					x2="769.93"
					y2="901.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="769.93"
					y1="901.79"
					x2="772.23"
					y2="902.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="772.23"
					y1="902.52"
					x2="774.52"
					y2="903.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="774.52"
					y1="903.57"
					x2="777.83"
					y2="905.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="777.83"
					y1="905.67"
					x2="781.25"
					y2="907.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="781.25"
					y1="907.53"
					x2="783.47"
					y2="908.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="783.47"
					y1="908.15"
					x2="785.76"
					y2="908.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="785.76"
					y1="908.29"
					x2="788.02"
					y2="907.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="788.02"
					y1="907.97"
					x2="790.12"
					y2="907.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="794.71"
					y1="897.8"
					x2="794.61"
					y2="898.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="794.61"
					y1="898.8"
					x2="793.97"
					y2="900.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="793.97"
					y1="900.86"
					x2="792.44"
					y2="902.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="792.44"
					y1="902.68"
					x2="790.31"
					y2="903.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="790.31"
					y1="903.82"
					x2="787.49"
					y2="904.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="787.49"
					y1="904.37"
					x2="784.59"
					y2="904.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="784.59"
					y1="904.49"
					x2="783.15"
					y2="904.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="783.15"
					y1="904.47"
					x2="782.01"
					y2="903.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="782.01"
					y1="903.86"
					x2="781.68"
					y2="903.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="781.68"
					y1="903.16"
					x2="779.42"
					y2="895.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="779.42"
					y1="895.23"
					x2="778.75"
					y2="891.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="778.75"
					y1="891.29"
					x2="778.46"
					y2="887.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="778.46"
					y1="887.31"
					x2="778.46"
					y2="884.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="726.7"
					y1="884.7"
					x2="727.06"
					y2="887.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="727.06"
					y1="887.83"
					x2="727.87"
					y2="890.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="727.87"
					y1="890.86"
					x2="729.41"
					y2="894.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="729.41"
					y1="894.08"
					x2="731.96"
					y2="897.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="731.96"
					y1="897.05"
					x2="735.15"
					y2="899.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="735.15"
					y1="899.3"
					x2="738.8"
					y2="900.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="738.8"
					y1="900.96"
					x2="742.66"
					y2="902.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="742.66"
					y1="902.16"
					x2="748.91"
					y2="903.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="748.91"
					y1="903.24"
					x2="752.06"
					y2="903.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.06"
					y1="903.3"
					x2="755.2"
					y2="902.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="755.2"
					y1="902.95"
					x2="760.07"
					y2="901.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="760.07"
					y1="901.53"
					x2="764.78"
					y2="899.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="764.78"
					y1="899.32"
					x2="768.99"
					y2="896.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="768.99"
					y1="896.7"
					x2="772.36"
					y2="894.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="779.43"
					y1="862.74"
					x2="778.72"
					y2="863.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="778.72"
					y1="863.25"
					x2="777.65"
					y2="864.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="777.65"
					y1="864.69"
					x2="777.4"
					y2="865.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="777.4"
					y1="865.94"
					x2="776.71"
					y2="873.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="776.71"
					y1="873.99"
					x2="776.4"
					y2="882.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="776.4"
					y1="882.06"
					x2="776.4"
					y2="884.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="779.43"
					y1="906.66"
					x2="778.72"
					y2="906.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="778.72"
					y1="906.16"
					x2="777.65"
					y2="904.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="777.65"
					y1="904.72"
					x2="777.4"
					y2="903.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="777.4"
					y1="903.46"
					x2="776.71"
					y2="895.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="776.71"
					y1="895.42"
					x2="776.4"
					y2="887.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="776.4"
					y1="887.35"
					x2="776.4"
					y2="884.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="792.78"
					y1="905.13"
					x2="793.37"
					y2="904.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="793.37"
					y1="904.41"
					x2="794.61"
					y2="902.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="794.61"
					y1="902.18"
					x2="795.3"
					y2="900.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="795.3"
					y1="900.04"
					x2="795.65"
					y2="897.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="743.03 770.74 743.03 844.91 795.65 844.91 795.65 770.74 743.03 770.74"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="743.03"
					y1="770.74"
					x2="743.03"
					y2="844.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="795.65"
					y1="770.74"
					x2="795.65"
					y2="844.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="743.03"
					y1="844.91"
					x2="795.65"
					y2="844.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="743.03"
					y1="770.74"
					x2="795.65"
					y2="770.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="793.67"
					y1="770.74"
					x2="793.67"
					y2="844.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="756.1"
					y1="782.6"
					x2="756.1"
					y2="833.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="756.1"
					y1="833.05"
					x2="786.37"
					y2="833.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="786.37"
					y1="833.05"
					x2="786.37"
					y2="782.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="786.37"
					y1="782.6"
					x2="756.1"
					y2="782.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="754.11"
					y1="780.61"
					x2="754.11"
					y2="835.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="754.11"
					y1="835.03"
					x2="788.36"
					y2="835.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="788.36"
					y1="835.03"
					x2="788.36"
					y2="780.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="788.36"
					y1="780.61"
					x2="754.11"
					y2="780.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m782.51,807.82c0-1.64-1.33-2.98-2.98-2.98s-2.98,1.34-2.98,2.98,1.34,2.98,2.98,2.98,2.98-1.34,2.98-2.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="793.07 805.34 788.91 805.74 787.96 806.06 782.71 806.72 782.01 807.09 781.73 807.82 782.01 808.56 782.71 808.93 787.96 809.58 788.91 809.91 793.07 810.31 794.54 809.83 795.44 808.59 795.44 807.06 794.54 805.82 793.07 805.34"
					fill="none"
					fillRule="evenodd"
				/>
				<path
					d="m793.07,805.34c1.37,0,2.48,1.11,2.48,2.48s-1.11,2.48-2.48,2.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="788.91"
					y1="809.91"
					x2="793.07"
					y2="810.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m788.91,809.91c-.34-.03-.66-.14-.95-.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="782.71"
					y1="808.93"
					x2="787.96"
					y2="809.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m782.71,808.93c-.56-.07-.97-.54-.97-1.1s.42-1.03.97-1.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="787.96"
					y1="806.06"
					x2="782.71"
					y2="806.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m787.96,806.06c.29-.18.61-.3.95-.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="793.07"
					y1="805.34"
					x2="788.91"
					y2="805.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="790.6"
					y1="809.18"
					x2="789.13"
					y2="809.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="789.13"
					y1="806.47"
					x2="790.6"
					y2="806.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="790.6"
					y1="806.47"
					x2="790.6"
					y2="809.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m789.13,809.18c-.75,0-1.35-.61-1.35-1.35s.6-1.35,1.35-1.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m787.96,809.58c-.6-.38-.96-1.05-.96-1.76s.36-1.38.96-1.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="795.65 854.43 794.64 854.43 794.64 859.48 795.65 859.48 795.65 854.43"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="795.65"
					y1="859.48"
					x2="795.65"
					y2="854.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="794.64"
					y1="859.48"
					x2="795.65"
					y2="859.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="794.64"
					y1="854.43"
					x2="794.64"
					y2="859.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="795.65"
					y1="854.43"
					x2="794.64"
					y2="854.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="795.65 914.97 795.65 909.92 794.64 909.92 794.64 914.97 795.65 914.97"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="794.64"
					y1="914.97"
					x2="795.65"
					y2="914.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="794.64"
					y1="909.92"
					x2="794.64"
					y2="914.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="795.65"
					y1="909.92"
					x2="794.64"
					y2="909.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="795.65"
					y1="914.97"
					x2="795.65"
					y2="909.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="794.64 856.45 786.43 856.45 786.43 857.46 794.64 857.46 794.64 856.45"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="794.64"
					y1="857.46"
					x2="794.64"
					y2="856.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="786.43"
					y1="857.46"
					x2="794.64"
					y2="857.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="786.43"
					y1="856.45"
					x2="786.43"
					y2="857.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="794.64"
					y1="856.45"
					x2="786.43"
					y2="856.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="794.64 912.95 794.64 911.95 786.43 911.95 786.43 912.95 794.64 912.95"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="786.43"
					y1="912.95"
					x2="794.64"
					y2="912.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="786.43"
					y1="911.95"
					x2="786.43"
					y2="912.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="794.64"
					y1="911.95"
					x2="786.43"
					y2="911.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="794.64"
					y1="912.95"
					x2="794.64"
					y2="911.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="788.96 857.46 786.94 857.46 786.94 911.95 788.96 911.95 788.96 857.46"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="788.96"
					y1="911.95"
					x2="788.96"
					y2="857.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="786.94"
					y1="911.95"
					x2="788.96"
					y2="911.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="786.94"
					y1="857.46"
					x2="786.94"
					y2="911.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="788.96"
					y1="857.46"
					x2="786.94"
					y2="857.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="623.56 696.57 623.56 770.74 777.97 770.74 777.97 696.57 623.56 696.57"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="777.97"
					y1="696.57"
					x2="623.56"
					y2="696.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="777.97"
					y1="770.74"
					x2="777.97"
					y2="696.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="623.56"
					y1="770.74"
					x2="777.97"
					y2="770.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="623.56"
					y1="696.57"
					x2="623.56"
					y2="770.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="773"
					y1="701.54"
					x2="628.53"
					y2="701.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="628.53"
					y1="701.54"
					x2="628.53"
					y2="765.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="628.53"
					y1="765.77"
					x2="773"
					y2="765.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="773"
					y1="765.77"
					x2="773"
					y2="701.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="773"
					y1="701.54"
					x2="708.13"
					y2="730.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="773"
					y1="765.77"
					x2="708.13"
					y2="736.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="628.53"
					y1="701.54"
					x2="693.4"
					y2="730.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="628.53"
					y1="765.77"
					x2="693.4"
					y2="736.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="700.77"
					y1="728.69"
					x2="700.77"
					y2="738.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="695.8"
					y1="733.65"
					x2="705.73"
					y2="733.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m708.71,733.65c0-4.39-3.55-7.94-7.94-7.94s-7.95,3.56-7.95,7.94,3.56,7.94,7.95,7.94,7.94-3.55,7.94-7.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m705.73,733.65c0-2.74-2.22-4.97-4.97-4.97s-4.97,2.22-4.97,4.97,2.22,4.97,4.97,4.97,4.97-2.22,4.97-4.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="777.97 733.65 767.43 725.9 767.43 741.41 777.97 733.65"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="767.43"
					y1="741.41"
					x2="777.97"
					y2="733.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="767.43"
					y1="725.9"
					x2="767.43"
					y2="741.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="777.97"
					y1="733.65"
					x2="767.43"
					y2="725.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="765.02"
					y1="733.65"
					x2="758.56"
					y2="733.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="767.43"
					y1="733.65"
					x2="767.43"
					y2="741.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="767.43"
					y1="741.41"
					x2="777.97"
					y2="733.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="767.43"
					y1="733.65"
					x2="767.43"
					y2="725.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="767.43"
					y1="725.9"
					x2="777.97"
					y2="733.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="765.23"
					y1="735.94"
					x2="759.62"
					y2="739.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="765.23"
					y1="731.37"
					x2="759.62"
					y2="728.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="274.47 682.2 216.91 682.2 216.91 738.77 274.47 738.77 274.47 682.2"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="274.47"
					y1="738.77"
					x2="274.47"
					y2="736.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="274.47"
					y1="732.88"
					x2="274.47"
					y2="726.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="274.47"
					y1="723.2"
					x2="274.47"
					y2="717.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="274.47"
					y1="713.51"
					x2="274.47"
					y2="707.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="274.47"
					y1="703.83"
					x2="274.47"
					y2="697.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="274.47"
					y1="694.14"
					x2="274.47"
					y2="688.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="274.47"
					y1="684.45"
					x2="274.47"
					y2="682.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="216.91"
					y1="738.77"
					x2="219.66"
					y2="738.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="223.29"
					y1="738.77"
					x2="229.34"
					y2="738.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="232.98"
					y1="738.77"
					x2="239.03"
					y2="738.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="242.66"
					y1="738.77"
					x2="248.72"
					y2="738.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="252.35"
					y1="738.77"
					x2="258.4"
					y2="738.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="262.04"
					y1="738.77"
					x2="268.09"
					y2="738.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="271.72"
					y1="738.77"
					x2="274.47"
					y2="738.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="216.91"
					y1="682.2"
					x2="216.91"
					y2="684.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="216.91"
					y1="688.08"
					x2="216.91"
					y2="694.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="216.91"
					y1="697.77"
					x2="216.91"
					y2="703.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="216.91"
					y1="707.46"
					x2="216.91"
					y2="713.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="216.91"
					y1="717.14"
					x2="216.91"
					y2="723.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="216.91"
					y1="726.83"
					x2="216.91"
					y2="732.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="216.91"
					y1="736.51"
					x2="216.91"
					y2="738.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="274.47"
					y1="682.2"
					x2="271.72"
					y2="682.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="268.09"
					y1="682.2"
					x2="262.04"
					y2="682.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="258.4"
					y1="682.2"
					x2="252.35"
					y2="682.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="248.72"
					y1="682.2"
					x2="242.66"
					y2="682.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="239.03"
					y1="682.2"
					x2="232.98"
					y2="682.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="229.34"
					y1="682.2"
					x2="223.29"
					y2="682.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="219.66"
					y1="682.2"
					x2="216.91"
					y2="682.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="277.45 738.55 279.19 738.55 279.19 682.42 277.45 682.42 277.45 691.22 278.87 691.22 278.87 729.75 277.45 729.75 277.45 738.55"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="277.45"
					y1="729.75"
					x2="277.45"
					y2="738.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".26"
				/>
				<line
					x1="278.87"
					y1="729.75"
					x2="277.45"
					y2="729.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".26"
				/>
				<line
					x1="278.87"
					y1="691.22"
					x2="278.87"
					y2="729.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".26"
				/>
				<line
					x1="277.45"
					y1="691.22"
					x2="278.87"
					y2="691.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".26"
				/>
				<line
					x1="277.45"
					y1="682.42"
					x2="277.45"
					y2="691.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".26"
				/>
				<line
					x1="279.19"
					y1="682.42"
					x2="277.45"
					y2="682.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".26"
				/>
				<line
					x1="279.19"
					y1="738.55"
					x2="279.19"
					y2="682.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".26"
				/>
				<line
					x1="277.45"
					y1="738.55"
					x2="279.19"
					y2="738.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".26"
				/>
				<polyline
					points="277.45 740.75 277.45 680.21 274.47 680.21 274.47 740.75 277.45 740.75"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="274.47"
					y1="740.75"
					x2="277.45"
					y2="740.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".26"
				/>
				<line
					x1="274.47"
					y1="680.21"
					x2="274.47"
					y2="740.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".26"
				/>
				<line
					x1="277.45"
					y1="680.21"
					x2="274.47"
					y2="680.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".26"
				/>
				<line
					x1="277.45"
					y1="740.75"
					x2="277.45"
					y2="680.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".26"
				/>
				<line
					x1="277.45"
					y1="682.42"
					x2="279.19"
					y2="682.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="279.19"
					y1="682.42"
					x2="279.19"
					y2="738.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="279.19"
					y1="738.55"
					x2="277.45"
					y2="738.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="277.45"
					y1="680.21"
					x2="277.45"
					y2="740.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="277.45"
					y1="729.75"
					x2="278.87"
					y2="729.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="278.87"
					y1="729.75"
					x2="278.87"
					y2="691.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="278.87"
					y1="691.22"
					x2="277.45"
					y2="691.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="274.47"
					y1="680.21"
					x2="277.45"
					y2="680.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="277.45"
					y1="740.75"
					x2="274.47"
					y2="740.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="274.47"
					y1="740.75"
					x2="274.47"
					y2="680.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="285.41 928.56 285.41 843.7 193.8 843.7 193.8 928.56 285.41 928.56"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="193.8"
					y1="928.56"
					x2="285.41"
					y2="928.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="193.8"
					y1="843.7"
					x2="193.8"
					y2="928.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="285.41"
					y1="843.7"
					x2="193.8"
					y2="843.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="285.41"
					y1="928.56"
					x2="285.41"
					y2="843.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="279.11"
					y1="928.56"
					x2="279.11"
					y2="843.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="282.49 818.7 282.49 743.03 216.91 743.03 216.91 818.7 282.49 818.7"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="282.49"
					y1="818.7"
					x2="282.49"
					y2="743.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="216.91"
					y1="818.7"
					x2="216.91"
					y2="743.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="218.9"
					y1="818.7"
					x2="218.9"
					y2="743.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="282.49"
					y1="818.7"
					x2="216.91"
					y2="818.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="282.49"
					y1="743.03"
					x2="216.91"
					y2="743.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="279.51"
					y1="813.74"
					x2="279.51"
					y2="748"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="279.51"
					y1="748"
					x2="277.53"
					y2="746.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="277.53"
					y1="746.01"
					x2="221.88"
					y2="746.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="221.88"
					y1="746.01"
					x2="219.89"
					y2="748"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="219.89"
					y1="748"
					x2="219.89"
					y2="813.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="219.89"
					y1="813.74"
					x2="221.88"
					y2="815.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="221.88"
					y1="815.73"
					x2="277.53"
					y2="815.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="277.53"
					y1="815.73"
					x2="279.51"
					y2="813.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m276.03,799.79c0-5.49-4.45-9.93-9.93-9.93s-9.93,4.45-9.93,9.93,4.45,9.93,9.93,9.93,9.93-4.45,9.93-9.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m240.75,799.79c0-4.11-3.33-7.45-7.45-7.45s-7.45,3.33-7.45,7.45,3.33,7.45,7.45,7.45,7.45-3.33,7.45-7.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m273.55,761.95c0-4.11-3.33-7.45-7.45-7.45s-7.45,3.33-7.45,7.45,3.33,7.45,7.45,7.45,7.45-3.33,7.45-7.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m243.24,761.95c0-5.49-4.45-9.93-9.93-9.93s-9.93,4.45-9.93,9.93,4.45,9.93,9.93,9.93,9.93-4.45,9.93-9.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="272.4 673.38 272.4 618.55 272.14 617.56 271.41 616.83 270.42 616.57 218.9 616.57 217.9 616.83 217.18 617.56 216.91 618.55 216.91 673.38 217.18 674.37 217.9 675.1 218.9 675.37 270.42 675.37 271.41 675.1 272.14 674.37 272.4 673.38"
					fill="none"
					fillRule="evenodd"
				/>
				<path
					d="m272.4,673.38c0,1.1-.89,1.99-1.99,1.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="218.9"
					y1="675.37"
					x2="270.42"
					y2="675.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m218.9,675.37c-1.1,0-1.99-.89-1.99-1.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="216.91"
					y1="618.55"
					x2="216.91"
					y2="673.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m216.91,618.55c0-1.09.89-1.99,1.99-1.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="270.42"
					y1="616.57"
					x2="218.9"
					y2="616.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m270.42,616.57c1.1,0,1.99.89,1.99,1.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="272.4"
					y1="673.38"
					x2="272.4"
					y2="618.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="267.44"
					y1="668.42"
					x2="267.44"
					y2="623.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="265.45"
					y1="621.53"
					x2="228.83"
					y2="621.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="226.84"
					y1="623.52"
					x2="226.84"
					y2="668.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="228.83"
					y1="670.4"
					x2="265.45"
					y2="670.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="267.44"
					y1="668.42"
					x2="267.44"
					y2="668.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m265.45,621.53c1.1,0,1.98.89,1.98,1.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m226.84,623.52c0-1.1.89-1.99,1.99-1.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m228.83,670.4c-1.1,0-1.99-.89-1.99-1.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m267.44,668.42c0,1.1-.89,1.99-1.98,1.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m239.75,645.97c0-1.65-1.33-2.98-2.98-2.98s-2.98,1.33-2.98,2.98,1.33,2.98,2.98,2.98,2.98-1.34,2.98-2.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="239.54 646.86 240.17 646.6 240.43 645.97 240.17 645.34 239.54 645.08 219.89 645.08 219.26 645.34 219 645.97 219.26 646.6 219.89 646.86 239.54 646.86"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="219.89"
					y1="646.86"
					x2="239.54"
					y2="646.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m219.89,646.86c-.49,0-.89-.4-.89-.9s.4-.89.89-.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="239.54"
					y1="645.08"
					x2="219.89"
					y2="645.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m239.54,645.08h0c.49,0,.89.4.89.89s-.4.9-.89.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="224.95 647.95 224.95 646.86 219.89 646.86 219.26 646.6 219 645.97 219.26 645.34 219.89 645.08 224.95 645.08 224.95 643.99 218.5 643.99 218.5 647.95 224.95 647.95"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="218.5"
					y1="647.95"
					x2="224.95"
					y2="647.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="218.5"
					y1="643.99"
					x2="218.5"
					y2="647.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="224.95"
					y1="643.99"
					x2="218.5"
					y2="643.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="224.95"
					y1="645.08"
					x2="224.95"
					y2="643.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="219.89"
					y1="645.08"
					x2="224.95"
					y2="645.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m219.89,646.86c-.49,0-.89-.4-.89-.9s.4-.89.89-.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="224.95"
					y1="646.86"
					x2="219.89"
					y2="646.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="224.95"
					y1="647.95"
					x2="224.95"
					y2="646.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="228.53 647.92 228.53 646.86 225.05 646.86 225.05 647.92 228.53 647.92"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="225.05"
					y1="647.92"
					x2="228.53"
					y2="647.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="225.05"
					y1="646.86"
					x2="225.05"
					y2="647.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="228.53"
					y1="646.86"
					x2="225.05"
					y2="646.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="228.53"
					y1="647.92"
					x2="228.53"
					y2="646.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="228.53 644.01 225.05 644.01 225.05 645.08 228.53 645.08 228.53 644.01"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="228.53"
					y1="645.08"
					x2="228.53"
					y2="644.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="225.05"
					y1="645.08"
					x2="228.53"
					y2="645.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="225.05"
					y1="644.01"
					x2="225.05"
					y2="645.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="228.53"
					y1="644.01"
					x2="225.05"
					y2="644.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="737.92"
					y1="598.06"
					x2="720.26"
					y2="598.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="720.26"
					y1="598.06"
					x2="720.26"
					y2="645.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="737.92"
					y1="587.97"
					x2="737.92"
					y2="656.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="783.32"
					y1="656.08"
					x2="783.32"
					y2="587.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="783.32"
					y1="587.97"
					x2="715.21"
					y2="587.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="715.21"
					y1="656.08"
					x2="783.32"
					y2="656.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="716.47"
					y1="587.97"
					x2="716.47"
					y2="656.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="737.92"
					y1="645.99"
					x2="720.26"
					y2="645.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="715.21"
					y1="587.97"
					x2="715.21"
					y2="656.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="285.41"
					y1="846.22"
					x2="290.4"
					y2="846.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="290.4"
					y1="846.22"
					x2="290.4"
					y2="848.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="290.4"
					y1="848.74"
					x2="285.41"
					y2="848.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="277.45"
					y1="928.56"
					x2="277.45"
					y2="926.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="277.45"
					y1="923.06"
					x2="277.45"
					y2="917"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="277.45"
					y1="913.37"
					x2="277.45"
					y2="907.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="277.45"
					y1="903.68"
					x2="277.45"
					y2="897.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="277.45"
					y1="894"
					x2="277.45"
					y2="887.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="277.45"
					y1="884.31"
					x2="277.45"
					y2="878.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="277.45"
					y1="874.63"
					x2="277.45"
					y2="868.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="277.45"
					y1="864.94"
					x2="277.45"
					y2="858.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="277.45"
					y1="855.25"
					x2="277.45"
					y2="849.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="277.45"
					y1="845.57"
					x2="277.45"
					y2="843.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="247.18"
					y1="843.7"
					x2="247.18"
					y2="838.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="247.18"
					y1="834.77"
					x2="247.18"
					y2="828.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="247.18"
					y1="825.08"
					x2="247.18"
					y2="819.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="247.18"
					y1="815.4"
					x2="247.18"
					y2="809.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="247.18"
					y1="805.71"
					x2="247.18"
					y2="799.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="247.18"
					y1="796.02"
					x2="247.18"
					y2="789.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="247.18"
					y1="786.34"
					x2="247.18"
					y2="780.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="247.18"
					y1="776.65"
					x2="247.18"
					y2="770.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="247.18"
					y1="766.97"
					x2="247.18"
					y2="760.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="247.18"
					y1="757.28"
					x2="247.18"
					y2="751.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="247.18"
					y1="747.59"
					x2="247.18"
					y2="741.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="247.18"
					y1="737.91"
					x2="247.18"
					y2="731.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="247.18"
					y1="728.22"
					x2="247.18"
					y2="722.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="247.18"
					y1="718.54"
					x2="247.18"
					y2="712.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="247.18"
					y1="708.85"
					x2="247.18"
					y2="702.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="247.18"
					y1="699.16"
					x2="247.18"
					y2="693.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="247.18"
					y1="689.48"
					x2="247.18"
					y2="683.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="247.18"
					y1="679.79"
					x2="247.18"
					y2="673.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="247.18"
					y1="670.11"
					x2="247.18"
					y2="664.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="247.18"
					y1="660.42"
					x2="247.18"
					y2="654.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="247.18"
					y1="650.73"
					x2="247.18"
					y2="644.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="247.18"
					y1="641.04"
					x2="247.18"
					y2="634.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="247.18"
					y1="631.36"
					x2="247.18"
					y2="625.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="247.18"
					y1="621.67"
					x2="247.18"
					y2="615.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="247.18"
					y1="611.98"
					x2="247.18"
					y2="605.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="247.18"
					y1="602.3"
					x2="247.18"
					y2="596.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="247.18"
					y1="592.61"
					x2="247.18"
					y2="586.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="247.18"
					y1="582.93"
					x2="247.18"
					y2="576.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="247.18"
					y1="573.24"
					x2="247.18"
					y2="567.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="247.18"
					y1="563.55"
					x2="247.18"
					y2="558.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="277.45"
					y1="843.7"
					x2="277.45"
					y2="818.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="277.45"
					y1="743.03"
					x2="277.45"
					y2="558.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="259.59"
					y1="50"
					x2="427.31"
					y2="50"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="427.31"
					y1="70.18"
					x2="259.59"
					y2="70.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="566.12"
					y1="50"
					x2="763.93"
					y2="50"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="763.93"
					y1="70.18"
					x2="569.55"
					y2="70.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="569.55"
					y1="70.18"
					x2="569.55"
					y2="64.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="569.55"
					y1="70.18"
					x2="566.12"
					y2="70.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="775.75"
					y1="598.06"
					x2="775.75"
					y2="645.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="775.75"
					y1="645.99"
					x2="742.96"
					y2="645.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="742.96"
					y1="645.99"
					x2="742.96"
					y2="598.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="742.96"
					y1="598.06"
					x2="775.75"
					y2="598.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
			</g>
			<g id="walls">
				<polygon
					points="509.57 928.56 509.57 948.73 173.62 948.73 173.62 823.51 196.73 823.51 196.73 565.83 173.62 565.83 173.62 50 259.58 50 259.58 70.19 193.8 70.19 193.8 545.65 397.35 545.65 397.35 558.26 216.9 558.26 216.9 843.7 193.8 843.7 193.8 928.56 509.57 928.56"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.11"
				/>
				<polygon
					points="826.38 50 826.38 622.5 804.64 622.5 804.64 704.14 798.14 704.14 798.14 750.56 815.83 750.56 815.83 948.73 605.42 948.73 605.42 928.56 610.95 928.56 610.95 913.54 623.57 913.54 623.57 928.56 795.66 928.56 795.66 770.74 777.97 770.74 777.97 696.57 623.57 696.57 623.57 832.82 610.95 832.82 610.95 683.96 700.45 683.96 700.45 658.38 713.06 658.38 713.06 683.96 784.47 683.96 784.47 602.31 806.2 602.31 806.2 582.53 713.06 582.53 713.06 587.76 700.45 587.76 700.45 558.26 600.51 558.26 600.51 545.65 647.92 545.65 647.92 536.31 660.54 536.31 660.54 545.65 806.2 545.65 806.2 396.27 660.54 396.27 660.54 465.68 647.92 465.68 647.92 383.67 806.2 383.67 806.2 70.19 763.92 70.19 763.92 50 826.38 50"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.11"
				/>
				<polygon
					points="566.12 50 566.12 70.19 532.26 70.19 532.26 153.38 504.14 153.38 504.14 545.65 519.78 545.65 519.78 558.26 478.08 558.26 478.08 545.65 491.53 545.65 491.53 153.38 464.88 153.38 464.88 70.19 427.31 70.19 427.31 50 566.12 50"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.11"
				/>
			</g>
			<g id="text">
				<path d="m237.14,715.76v-11.7h4.03c.91,0,1.6.06,2.08.17.67.15,1.24.43,1.72.84.62.52,1.08,1.19,1.38,2,.31.81.46,1.73.46,2.78,0,.89-.1,1.68-.31,2.36-.21.69-.47,1.26-.8,1.71-.32.45-.68.8-1.07,1.06-.38.26-.85.45-1.4.58-.54.13-1.17.2-1.87.2h-4.22Zm1.55-1.38h2.5c.77,0,1.37-.07,1.81-.22.44-.14.79-.35,1.05-.61.37-.37.65-.86.85-1.48.21-.62.31-1.37.31-2.26,0-1.22-.2-2.16-.61-2.82-.4-.66-.89-1.1-1.46-1.32-.41-.16-1.08-.24-2-.24h-2.46v8.94Zm12.3,1.38l-3.1-11.7h1.59l1.78,7.67c.19.8.36,1.6.49,2.39.3-1.25.47-1.97.53-2.16l2.23-7.9h1.87l1.68,5.92c.42,1.47.72,2.85.91,4.14.15-.74.34-1.59.58-2.54l1.83-7.52h1.56l-3.21,11.7h-1.49l-2.47-8.91c-.21-.74-.33-1.2-.37-1.37-.12.54-.24.99-.34,1.37l-2.48,8.91h-1.58Z" />
				<path d="m235.91,893.14h-1.64l-1.97-3.3c-.18-.31-.36-.57-.53-.78-.17-.22-.35-.4-.53-.53-.18-.14-.37-.24-.58-.3-.2-.07-.43-.1-.69-.1h-1.13v5.01h-1.38v-11.78h3.52c.51,0,.99.07,1.42.2.44.13.82.32,1.13.58.32.26.58.59.76.99.18.39.27.85.27,1.37,0,.41-.06.79-.19,1.13-.12.34-.3.64-.53.91-.22.27-.5.5-.82.69-.32.19-.68.33-1.08.44v.03c.2.09.37.19.51.3.15.11.29.24.42.39.13.15.26.33.39.53.13.19.28.42.44.67l2.21,3.54Zm-7.06-10.53v4.27h1.87c.35,0,.66-.05.95-.16.3-.1.55-.25.76-.44.21-.2.38-.44.5-.71.12-.28.18-.6.18-.95,0-.63-.21-1.12-.62-1.47-.41-.36-.99-.53-1.77-.53h-1.89Zm15.11,6.66h-5.94c.02.94.27,1.66.76,2.17.48.51,1.14.76,1.99.76.95,0,1.82-.31,2.61-.94v1.27c-.74.54-1.72.81-2.93.81s-2.12-.38-2.8-1.14c-.68-.77-1.02-1.84-1.02-3.23,0-1.31.37-2.37,1.11-3.2.74-.83,1.67-1.24,2.77-1.24s1.95.36,2.55,1.07c.6.71.9,1.7.9,2.97v.71Zm-1.38-1.14c0-.78-.19-1.38-.57-1.82-.37-.43-.88-.65-1.54-.65s-1.17.23-1.62.68c-.44.45-.72,1.05-.82,1.78h4.54Zm7.42-6.26c-.26-.15-.56-.22-.9-.22-.94,0-1.41.59-1.41,1.78v1.3h1.97v1.15h-1.97v7.26h-1.34v-7.26h-1.44v-1.15h1.44v-1.36c0-.88.25-1.58.76-2.09.51-.51,1.14-.77,1.91-.77.41,0,.74.05.98.15v1.22Z" />
				<path d="m251.42,893.32c-.25,0-.47-.09-.65-.27-.18-.18-.26-.4-.26-.65s.09-.47.26-.65c.18-.19.4-.28.65-.28s.48.09.66.28c.18.18.27.4.27.65s-.09.47-.27.65c-.18.18-.4.27-.66.27Z" />
				<path d="m684.63,860.45v-18.28h5.2c1.58,0,2.83.39,3.76,1.16.93.77,1.39,1.78,1.39,3.02,0,1.04-.28,1.94-.84,2.7-.56.76-1.33,1.31-2.32,1.63v.05c1.23.14,2.22.61,2.96,1.4.74.78,1.11,1.8,1.11,3.06,0,1.56-.56,2.83-1.68,3.8-1.12.97-2.54,1.45-4.25,1.45h-5.33Zm2.14-16.34v5.9h2.19c1.17,0,2.1-.28,2.77-.84.67-.57,1.01-1.37,1.01-2.4,0-1.78-1.17-2.66-3.51-2.66h-2.46Zm0,7.83v6.58h2.91c1.26,0,2.23-.3,2.92-.89.7-.59,1.05-1.41,1.05-2.45,0-2.16-1.47-3.24-4.41-3.24h-2.46Zm21.88,8.52h-2.09v-2.04h-.05c-.91,1.56-2.25,2.35-4.02,2.35-1.3,0-2.32-.34-3.06-1.03-.73-.69-1.1-1.6-1.1-2.74,0-2.44,1.44-3.86,4.31-4.26l3.91-.55c0-2.22-.9-3.33-2.69-3.33-1.57,0-2.99.54-4.26,1.61v-2.14c1.28-.82,2.76-1.22,4.44-1.22,3.07,0,4.6,1.62,4.6,4.87v8.49Zm-2.09-6.6l-3.15.43c-.97.14-1.7.38-2.19.73-.49.34-.74.95-.74,1.82,0,.64.23,1.16.68,1.57.46.4,1.07.6,1.82.6,1.04,0,1.89-.36,2.56-1.08.68-.73,1.02-1.65,1.02-2.77v-1.3Zm12.09,6.48c-.49.27-1.14.41-1.95.41-2.29,0-3.43-1.27-3.43-3.82v-7.73h-2.24v-1.78h2.24v-3.19l2.09-.68v3.86h3.29v1.78h-3.29v7.36c0,.88.15,1.5.45,1.87.3.37.79.56,1.48.56.53,0,.98-.14,1.36-.43v1.78Zm13.63.13h-2.09v-7.52c0-2.72-1.01-4.08-3.03-4.08-1.02,0-1.88.4-2.58,1.19-.7.78-1.05,1.79-1.05,3.02v7.39h-2.09v-19.33h2.09v8.44h.05c1-1.65,2.43-2.47,4.28-2.47,2.94,0,4.41,1.77,4.41,5.32v8.04Z" />
				<path d="m294.58,311.87v-18.28h5.2c1.58,0,2.83.39,3.76,1.16.93.77,1.39,1.78,1.39,3.02,0,1.04-.28,1.94-.84,2.7-.56.76-1.33,1.31-2.32,1.63v.05c1.23.14,2.22.61,2.96,1.4.74.78,1.11,1.8,1.11,3.06,0,1.56-.56,2.83-1.68,3.8-1.12.97-2.54,1.45-4.25,1.45h-5.33Zm2.14-16.34v5.9h2.19c1.17,0,2.1-.28,2.77-.84.67-.57,1.01-1.37,1.01-2.4,0-1.78-1.17-2.66-3.51-2.66h-2.46Zm0,7.83v6.58h2.91c1.26,0,2.23-.3,2.92-.89.7-.6,1.05-1.41,1.05-2.45,0-2.16-1.47-3.24-4.41-3.24h-2.46Zm23.01,2.51h-9.22c.03,1.45.42,2.58,1.17,3.37s1.78,1.19,3.09,1.19c1.47,0,2.82-.48,4.05-1.45v1.96c-1.15.83-2.66,1.25-4.55,1.25s-3.29-.59-4.35-1.77c-1.05-1.19-1.58-2.86-1.58-5.01,0-2.03.57-3.68,1.72-4.96,1.16-1.28,2.59-1.93,4.3-1.93s3.03.55,3.97,1.66c.93,1.1,1.4,2.64,1.4,4.6v1.1Zm-2.14-1.77c0-1.21-.3-2.15-.88-2.82-.57-.67-1.36-1.01-2.38-1.01s-1.82.35-2.51,1.06c-.69.71-1.11,1.63-1.27,2.77h7.05Zm16.43,7.78h-2.09v-2.22h-.05c-.97,1.68-2.46,2.52-4.49,2.52-1.64,0-2.95-.58-3.94-1.75-.98-1.17-1.47-2.77-1.47-4.78,0-2.16.54-3.89,1.63-5.19,1.09-1.3,2.54-1.95,4.35-1.95s3.1.71,3.91,2.12h.05v-8.08h2.09v19.33Zm-2.09-5.9v-1.93c0-1.05-.35-1.95-1.05-2.68-.7-.73-1.58-1.1-2.65-1.1-1.27,0-2.28.47-3.01,1.4-.73.93-1.1,2.23-1.1,3.88,0,1.5.35,2.69,1.05,3.57.71.87,1.65,1.3,2.83,1.3s2.11-.42,2.83-1.26c.73-.84,1.1-1.9,1.1-3.19Zm13.12-5.04c-.37-.28-.89-.42-1.58-.42-.89,0-1.64.42-2.24,1.26-.59.84-.89,1.99-.89,3.44v6.66h-2.09v-13.06h2.09v2.69h.05c.3-.92.75-1.63,1.36-2.14.61-.52,1.3-.78,2.05-.78.54,0,.96.06,1.25.18v2.17Zm7.71,11.25c-1.93,0-3.47-.61-4.63-1.82-1.15-1.22-1.72-2.84-1.72-4.86,0-2.19.6-3.91,1.8-5.14,1.2-1.23,2.82-1.85,4.86-1.85s3.46.6,4.55,1.8c1.1,1.2,1.64,2.86,1.64,4.99s-.59,3.75-1.77,5.01c-1.17,1.25-2.75,1.87-4.73,1.87Zm.15-11.91c-1.34,0-2.41.46-3.19,1.38-.78.91-1.17,2.17-1.17,3.77s.4,2.77,1.19,3.66c.79.89,1.85,1.34,3.17,1.34s2.39-.44,3.11-1.31c.73-.88,1.1-2.12,1.1-3.74s-.37-2.89-1.1-3.77c-.72-.88-1.76-1.33-3.11-1.33Zm15.13,11.91c-1.93,0-3.47-.61-4.63-1.82-1.15-1.22-1.72-2.84-1.72-4.86,0-2.19.6-3.91,1.8-5.14,1.2-1.23,2.82-1.85,4.86-1.85s3.46.6,4.55,1.8c1.1,1.2,1.64,2.86,1.64,4.99s-.59,3.75-1.77,5.01c-1.17,1.25-2.75,1.87-4.73,1.87Zm.15-11.91c-1.34,0-2.41.46-3.19,1.38-.78.91-1.17,2.17-1.17,3.77s.4,2.77,1.19,3.66c.79.89,1.85,1.34,3.17,1.34s2.39-.44,3.11-1.31c.73-.88,1.1-2.12,1.1-3.74s-.37-2.89-1.1-3.77c-.72-.88-1.76-1.33-3.11-1.33Zm28.21,11.6h-2.09v-7.5c0-1.44-.23-2.49-.68-3.14-.44-.65-1.19-.97-2.24-.97-.89,0-1.65.41-2.28,1.22-.62.82-.93,1.79-.93,2.93v7.45h-2.09v-7.75c0-2.57-.99-3.85-2.97-3.85-.92,0-1.67.39-2.27,1.16-.59.76-.89,1.76-.89,3v7.45h-2.09v-13.06h2.09v2.07h.05c.93-1.58,2.28-2.37,4.05-2.37.89,0,1.67.25,2.33.75.66.49,1.12,1.14,1.36,1.95.97-1.8,2.41-2.7,4.33-2.7,2.87,0,4.31,1.77,4.31,5.32v8.04Z" />
				<path d="m302.4,331.52c0,1.22-.12,2.3-.36,3.26-.24.95-.59,1.75-1.06,2.41-.46.66-1.03,1.16-1.7,1.5-.67.34-1.43.51-2.28.51s-1.65-.15-2.32-.46v-1.46c.74.41,1.52.62,2.36.62.6,0,1.13-.12,1.61-.37.48-.25.88-.61,1.21-1.08.33-.48.58-1.06.75-1.75.17-.69.26-1.49.26-2.38h-.04c-.57,1.14-1.56,1.72-2.97,1.72-.57,0-1.09-.1-1.57-.3-.48-.2-.89-.49-1.23-.85-.35-.37-.62-.81-.81-1.32-.19-.51-.29-1.07-.29-1.68,0-.66.11-1.26.32-1.8.22-.54.51-1.01.89-1.4.38-.4.84-.7,1.35-.92.53-.22,1.1-.32,1.72-.32.67,0,1.26.14,1.77.41.52.27.96.66,1.31,1.18.35.51.62,1.15.81,1.9.19.75.28,1.62.28,2.59Zm-1.64-1.36c0-.51-.07-.98-.2-1.4-.13-.42-.31-.78-.55-1.08-.24-.3-.52-.53-.84-.7-.32-.17-.67-.25-1.06-.25s-.71.07-1.02.22c-.32.14-.59.35-.83.61-.23.26-.41.57-.55.94-.13.36-.19.75-.19,1.18,0,.47.06.89.19,1.26.13.37.31.69.55.95.24.25.52.45.84.58.33.14.7.2,1.1.2.35,0,.68-.06.99-.19.32-.14.59-.32.82-.54.24-.23.42-.49.55-.8.14-.31.2-.64.2-.99Z" />
				<rect x="304.86" y="325.67" width="1.35" height="4.15" />
				<path d="m314.37,338.97h-1.52v-11.49c-.12.12-.29.25-.52.41-.22.15-.48.3-.76.45-.28.15-.58.29-.89.42-.31.13-.61.23-.91.31v-1.54c.33-.09.69-.22,1.06-.37.38-.16.75-.34,1.1-.53.36-.2.71-.4,1.03-.61.32-.22.6-.43.83-.63h.58v13.6Zm13-6.71c0,1.11-.1,2.1-.31,2.96-.2.86-.49,1.59-.87,2.18-.38.59-.84,1.04-1.4,1.35-.55.3-1.18.45-1.88.45-.67,0-1.26-.15-1.79-.44-.52-.3-.96-.73-1.32-1.29-.36-.56-.63-1.25-.82-2.07-.19-.82-.28-1.76-.28-2.82,0-1.16.1-2.19.29-3.08.2-.89.49-1.64.86-2.24.38-.61.84-1.06,1.4-1.36.56-.31,1.21-.46,1.93-.46,2.79,0,4.18,2.27,4.18,6.82Zm-1.56.15c0-3.79-.9-5.68-2.7-5.68-1.9,0-2.85,1.93-2.85,5.78,0,3.59.93,5.39,2.79,5.39s2.76-1.83,2.76-5.49Z" />
				<path d="m331.02,325.67v4.15h-1.35v-4.15h1.35Zm3.08,0v4.15h-1.35v-4.15h1.35Z" />
				<path d="m349.3,329.47l-3.19,4.81,3.14,4.69h-1.77l-1.86-3.08c-.12-.19-.26-.43-.42-.72h-.04c-.03.06-.18.3-.44.72l-1.9,3.08h-1.75l3.24-4.66-3.1-4.84h1.77l1.84,3.25c.14.24.27.49.4.74h.04l2.38-3.99h1.68Z" />
				<path d="m361.47,338.97h-1.52v-11.49c-.12.12-.29.25-.52.41-.22.15-.48.3-.76.45-.28.15-.58.29-.89.42-.31.13-.61.23-.91.31v-1.54c.33-.09.69-.22,1.06-.37.38-.16.75-.34,1.1-.53.36-.2.71-.4,1.03-.61.32-.22.6-.43.83-.63h.58v13.6Zm12.53-4.06c0,.65-.11,1.24-.33,1.76-.22.53-.54.98-.96,1.35-.41.38-.9.67-1.48.87-.58.2-1.23.31-1.94.31-1.24,0-2.16-.19-2.76-.56v-1.61c.9.58,1.83.87,2.77.87.48,0,.92-.07,1.3-.21.39-.14.72-.34.99-.59.27-.25.48-.56.62-.92.15-.36.22-.75.22-1.18,0-.87-.29-1.54-.87-2.03-.58-.49-1.43-.74-2.53-.74-.18,0-.37,0-.57,0-.2,0-.4.02-.59.03-.2,0-.39.02-.58.03-.19.01-.36.03-.51.05l.45-6.67h6.15v1.37h-4.83l-.27,3.91c.2-.01.41-.02.63-.03.22-.01.42-.02.59-.02.71,0,1.34.09,1.89.28.56.19,1.03.45,1.41.8.39.34.68.76.88,1.26.2.49.31,1.05.31,1.67Z" />
				<rect x="376.78" y="325.67" width="1.35" height="4.15" />
				<path d="m388.88,331.52c0,1.22-.12,2.3-.36,3.26-.24.95-.59,1.75-1.06,2.41-.46.66-1.03,1.16-1.7,1.5-.67.34-1.43.51-2.28.51s-1.65-.15-2.32-.46v-1.46c.74.41,1.52.62,2.36.62.6,0,1.13-.12,1.6-.37.48-.25.88-.61,1.21-1.08.33-.48.58-1.06.75-1.75.17-.69.26-1.49.26-2.38h-.04c-.57,1.14-1.56,1.72-2.97,1.72-.57,0-1.09-.1-1.57-.3-.48-.2-.89-.49-1.23-.85-.35-.37-.62-.81-.81-1.32-.19-.51-.29-1.07-.29-1.68,0-.66.11-1.26.32-1.8.22-.54.51-1.01.89-1.4.38-.4.84-.7,1.35-.92.53-.22,1.1-.32,1.72-.32.67,0,1.26.14,1.77.41.52.27.96.66,1.31,1.18.35.51.62,1.15.81,1.9.19.75.28,1.62.28,2.59Zm-1.64-1.36c0-.51-.07-.98-.2-1.4-.13-.42-.31-.78-.55-1.08-.24-.3-.52-.53-.84-.7-.32-.17-.67-.25-1.06-.25s-.71.07-1.02.22c-.32.14-.59.35-.83.61-.23.26-.41.57-.55.94-.13.36-.19.75-.19,1.18,0,.47.06.89.19,1.26.13.37.31.69.55.95.24.25.52.45.84.58.33.14.7.2,1.1.2.35,0,.68-.06.99-.19.32-.14.59-.32.82-.54.24-.23.42-.49.55-.8.14-.31.2-.64.2-.99Z" />
				<path d="m392.68,325.67v4.15h-1.35v-4.15h1.35Zm3.08,0v4.15h-1.35v-4.15h1.35Z" />
				<path d="m721.81,463.94l-3.76,13.3h-1.83l-2.74-9.72c-.12-.41-.19-.87-.21-1.35h-.04c-.04.46-.12.9-.24,1.34l-2.76,9.74h-1.81l-3.9-13.3h1.72l2.83,10.21c.12.43.19.87.22,1.34h.05c.03-.33.13-.77.29-1.34l2.94-10.21h1.49l2.82,10.28c.1.35.17.77.22,1.24h.04c.02-.32.11-.75.25-1.28l2.72-10.24h1.69Zm8.36,13.3h-1.52v-1.48h-.04c-.66,1.14-1.64,1.71-2.92,1.71-.95,0-1.69-.25-2.23-.75-.53-.5-.8-1.17-.8-1.99,0-1.78,1.05-2.81,3.14-3.1l2.85-.4c0-1.61-.65-2.42-1.96-2.42-1.14,0-2.18.39-3.1,1.17v-1.56c.93-.59,2.01-.89,3.23-.89,2.23,0,3.35,1.18,3.35,3.54v6.18Zm-1.52-4.81l-2.29.32c-.71.1-1.24.28-1.6.53-.36.25-.54.69-.54,1.33,0,.46.16.84.49,1.14.33.29.78.44,1.33.44.75,0,1.38-.26,1.86-.79.49-.53.74-1.2.74-2.01v-.95Zm5.71,4.81h-1.52v-14.06h1.52v14.06Zm10.76,0h-2.13l-4.19-4.56h-.04v4.56h-1.52v-14.06h1.52v8.92h.04l3.99-4.35h1.99l-4.41,4.58,4.75,4.92Z" />
				<rect x="746.27" y="471.35" width="5.07" height="1.2" />
				<path d="m755.84,477.25h-1.56v-13.3h1.56v13.3Zm11.19,0h-1.52v-5.42c0-2.02-.74-3.02-2.21-3.02-.76,0-1.39.29-1.89.86-.49.57-.74,1.29-.74,2.16v5.42h-1.52v-9.5h1.52v1.58h.04c.72-1.2,1.76-1.8,3.12-1.8,1.04,0,1.83.34,2.38,1.01.55.67.83,1.64.83,2.9v5.81Z" />
				<path d="m721.17,502.01c-.98.52-2.21.78-3.67.78-1.89,0-3.41-.61-4.55-1.83s-1.71-2.82-1.71-4.8c0-2.13.64-3.85,1.92-5.16,1.28-1.31,2.9-1.97,4.87-1.97,1.26,0,2.31.18,3.14.55v1.66c-.95-.53-2-.8-3.15-.8-1.53,0-2.77.51-3.72,1.53-.95,1.02-1.42,2.38-1.42,4.09s.44,2.91,1.33,3.88c.89.96,2.06,1.44,3.5,1.44,1.34,0,2.49-.3,3.47-.89v1.51Zm4.02.56h-1.52v-14.06h1.52v14.06Zm7.05.22c-1.4,0-2.53-.44-3.37-1.33-.84-.89-1.25-2.07-1.25-3.53,0-1.6.44-2.84,1.31-3.74.87-.9,2.05-1.35,3.53-1.35s2.52.44,3.31,1.31c.8.87,1.2,2.08,1.2,3.63s-.43,2.73-1.29,3.65c-.85.91-2,1.36-3.44,1.36Zm.11-8.67c-.98,0-1.75.33-2.32,1-.57.66-.85,1.58-.85,2.75s.29,2.01.86,2.66c.58.65,1.35.97,2.31.97s1.74-.32,2.26-.96c.53-.64.8-1.54.8-2.72s-.27-2.1-.8-2.75c-.53-.64-1.28-.96-2.26-.96Zm6.47,8.1v-1.63c.83.61,1.74.92,2.74.92,1.34,0,2-.45,2-1.34,0-.25-.06-.47-.18-.64-.11-.18-.27-.34-.46-.47-.19-.14-.42-.26-.69-.36-.26-.11-.54-.23-.84-.34-.42-.17-.79-.33-1.11-.5-.32-.17-.58-.36-.8-.58-.21-.22-.37-.46-.48-.73-.11-.27-.16-.59-.16-.96,0-.45.1-.84.31-1.18.2-.35.48-.63.82-.86.34-.24.73-.41,1.16-.53.44-.12.89-.18,1.35-.18.82,0,1.56.14,2.21.43v1.54c-.7-.46-1.5-.69-2.41-.69-.28,0-.54.03-.77.1-.23.06-.43.15-.59.27-.16.12-.29.26-.38.43-.09.16-.13.34-.13.54,0,.25.04.45.13.62.09.17.23.32.4.45.17.13.38.25.63.35.25.11.53.22.84.34.42.16.8.33,1.13.5.33.17.62.36.85.58.23.21.41.45.54.73.13.28.19.61.19.99,0,.47-.11.88-.32,1.22-.2.35-.48.63-.83.86s-.75.4-1.2.51c-.45.11-.92.17-1.42.17-.98,0-1.82-.19-2.54-.57Zm16.26-4.03h-6.71c.02,1.06.31,1.87.85,2.45.54.58,1.29.86,2.25.86,1.07,0,2.05-.35,2.95-1.06v1.43c-.83.61-1.94.91-3.31.91s-2.4-.43-3.16-1.29c-.77-.87-1.15-2.08-1.15-3.65,0-1.48.42-2.68,1.25-3.61.84-.93,1.88-1.4,3.13-1.4s2.2.4,2.89,1.21c.68.8,1.02,1.92,1.02,3.35v.8Zm-1.56-1.29c0-.88-.22-1.56-.64-2.05-.41-.49-.99-.73-1.73-.73s-1.33.26-1.83.77c-.5.51-.81,1.18-.93,2.01h5.13Zm8.26,5.57c-.36.2-.83.3-1.42.3-1.66,0-2.5-.93-2.5-2.78v-5.62h-1.63v-1.3h1.63v-2.32l1.52-.49v2.81h2.39v1.3h-2.39v5.35c0,.64.11,1.09.32,1.36.22.27.58.41,1.08.41.38,0,.71-.11.99-.32v1.3Z" />
				<path d="m533.57,834.59h-9.69v-18.28h9.28v1.94h-7.14v6.08h6.6v1.93h-6.6v6.4h7.55v1.94Zm14.1,0h-2.09v-7.45c0-2.77-1.01-4.16-3.03-4.16-1.05,0-1.91.4-2.6,1.19-.68.78-1.02,1.77-1.02,2.97v7.45h-2.09v-13.06h2.09v2.17h.05c.99-1.65,2.41-2.47,4.28-2.47,1.43,0,2.52.46,3.28,1.39.76.92,1.13,2.25,1.13,3.99v7.98Zm10.02-.13c-.49.27-1.14.41-1.95.41-2.29,0-3.43-1.27-3.43-3.82v-7.73h-2.24v-1.78h2.24v-3.19l2.09-.68v3.86h3.29v1.78h-3.29v7.36c0,.88.15,1.5.45,1.87.3.37.79.56,1.48.56.53,0,.98-.14,1.36-.43v1.78Zm9.62-10.81c-.37-.28-.89-.42-1.58-.42-.89,0-1.64.42-2.24,1.26-.59.84-.89,1.99-.89,3.44v6.66h-2.09v-13.06h2.09v2.69h.05c.3-.92.75-1.63,1.36-2.14.61-.52,1.3-.78,2.05-.78.54,0,.96.06,1.25.18v2.17Zm12.69-2.12l-6,15.15c-1.07,2.7-2.58,4.05-4.51,4.05-.54,0-1-.06-1.36-.17v-1.87c.45.15.86.23,1.24.23,1.05,0,1.84-.63,2.37-1.89l1.05-2.47-5.1-13.03h2.32l3.53,10.05c.04.13.13.46.27.99h.08c.04-.2.13-.53.25-.97l3.71-10.07h2.17Z" />
				<path d="m606.4,222.17v-18.28h5.2c1.58,0,2.83.39,3.76,1.16s1.39,1.78,1.39,3.02c0,1.04-.28,1.94-.84,2.7-.56.76-1.33,1.31-2.32,1.63v.05c1.23.14,2.22.61,2.96,1.4.74.78,1.11,1.8,1.11,3.06,0,1.56-.56,2.83-1.68,3.8-1.12.97-2.54,1.45-4.25,1.45h-5.33Zm2.14-16.34v5.9h2.19c1.17,0,2.1-.28,2.77-.84.67-.57,1.01-1.37,1.01-2.4,0-1.78-1.17-2.66-3.51-2.66h-2.46Zm0,7.83v6.58h2.91c1.26,0,2.23-.3,2.92-.89.7-.59,1.05-1.41,1.05-2.45,0-2.16-1.47-3.24-4.41-3.24h-2.46Zm23.01,2.51h-9.22c.03,1.45.42,2.58,1.17,3.37.75.79,1.78,1.19,3.09,1.19,1.47,0,2.82-.48,4.05-1.45v1.96c-1.15.83-2.66,1.25-4.55,1.25s-3.29-.59-4.35-1.77c-1.05-1.19-1.58-2.86-1.58-5.01,0-2.03.57-3.68,1.72-4.96,1.16-1.28,2.59-1.93,4.3-1.93s3.03.55,3.97,1.66,1.4,2.64,1.4,4.6v1.1Zm-2.14-1.77c0-1.21-.3-2.15-.88-2.82-.57-.67-1.36-1.01-2.38-1.01s-1.82.35-2.51,1.06-1.11,1.63-1.27,2.77h7.05Zm16.43,7.78h-2.09v-2.22h-.05c-.97,1.68-2.46,2.52-4.49,2.52-1.64,0-2.95-.58-3.94-1.75-.98-1.17-1.47-2.77-1.47-4.78,0-2.16.54-3.89,1.63-5.19s2.54-1.95,4.35-1.95,3.1.71,3.91,2.12h.05v-8.08h2.09v19.33Zm-2.09-5.9v-1.93c0-1.05-.35-1.95-1.05-2.68-.7-.73-1.58-1.1-2.65-1.1-1.28,0-2.28.47-3.01,1.4s-1.1,2.23-1.1,3.88c0,1.5.35,2.69,1.05,3.57.71.87,1.65,1.3,2.83,1.3s2.11-.42,2.83-1.26c.73-.84,1.1-1.9,1.1-3.19Zm13.12-5.04c-.37-.28-.89-.42-1.58-.42-.89,0-1.64.42-2.24,1.26-.59.84-.89,1.99-.89,3.44v6.66h-2.09v-13.06h2.09v2.69h.05c.3-.92.75-1.63,1.36-2.14.61-.52,1.3-.78,2.05-.78.54,0,.96.06,1.25.18v2.17Zm7.71,11.25c-1.93,0-3.47-.61-4.63-1.82-1.15-1.22-1.72-2.84-1.72-4.86,0-2.19.6-3.91,1.8-5.14,1.2-1.23,2.82-1.85,4.86-1.85s3.46.6,4.55,1.8c1.1,1.2,1.64,2.86,1.64,4.99s-.59,3.75-1.77,5.01c-1.17,1.25-2.75,1.87-4.73,1.87Zm.15-11.91c-1.34,0-2.41.46-3.19,1.38-.78.91-1.17,2.17-1.17,3.77s.4,2.77,1.19,3.66c.79.89,1.85,1.34,3.17,1.34s2.39-.44,3.11-1.31c.73-.88,1.1-2.12,1.1-3.74s-.37-2.89-1.1-3.77c-.72-.88-1.76-1.33-3.11-1.33Zm15.13,11.91c-1.93,0-3.47-.61-4.63-1.82-1.15-1.22-1.72-2.84-1.72-4.86,0-2.19.6-3.91,1.8-5.14,1.2-1.23,2.82-1.85,4.86-1.85s3.46.6,4.55,1.8c1.1,1.2,1.64,2.86,1.64,4.99s-.59,3.75-1.77,5.01c-1.17,1.25-2.75,1.87-4.73,1.87Zm.15-11.91c-1.34,0-2.41.46-3.19,1.38-.78.91-1.17,2.17-1.17,3.77s.4,2.77,1.19,3.66c.79.89,1.85,1.34,3.17,1.34s2.39-.44,3.11-1.31c.73-.88,1.1-2.12,1.1-3.74s-.37-2.89-1.1-3.77c-.72-.88-1.76-1.33-3.11-1.33Zm28.21,11.6h-2.09v-7.5c0-1.44-.23-2.49-.68-3.14-.44-.65-1.19-.97-2.24-.97-.89,0-1.65.41-2.28,1.22-.62.82-.93,1.79-.93,2.93v7.45h-2.09v-7.75c0-2.57-.99-3.85-2.97-3.85-.92,0-1.67.39-2.27,1.16-.6.76-.89,1.76-.89,3v7.45h-2.09v-13.06h2.09v2.07h.05c.93-1.58,2.28-2.37,4.05-2.37.89,0,1.67.25,2.33.75.66.49,1.12,1.14,1.36,1.95.97-1.8,2.41-2.7,4.33-2.7,2.87,0,4.31,1.77,4.31,5.32v8.04Z" />
				<path d="m611.63,249.27h-1.52v-11.49c-.12.12-.29.25-.52.41-.22.15-.48.3-.76.45-.28.15-.58.29-.89.42-.31.13-.61.23-.91.31v-1.54c.33-.09.69-.22,1.06-.37.38-.16.75-.34,1.1-.53.36-.2.71-.4,1.03-.61.32-.22.6-.43.84-.63h.58v13.6Zm13-6.71c0,1.11-.1,2.1-.31,2.96-.2.86-.49,1.59-.87,2.18-.38.59-.84,1.04-1.4,1.35-.55.3-1.18.45-1.88.45-.67,0-1.26-.15-1.79-.44-.52-.3-.96-.73-1.32-1.29-.36-.56-.63-1.25-.82-2.07-.19-.82-.28-1.76-.28-2.82,0-1.16.1-2.19.29-3.08.2-.89.49-1.64.86-2.24.38-.61.84-1.06,1.4-1.36.56-.31,1.21-.46,1.93-.46,2.79,0,4.18,2.27,4.18,6.82Zm-1.56.15c0-3.79-.9-5.68-2.7-5.68-1.9,0-2.85,1.93-2.85,5.78,0,3.59.93,5.39,2.79,5.39s2.76-1.83,2.76-5.49Z" />
				<rect x="626.94" y="235.97" width="1.35" height="4.15" />
				<path d="m639.19,242.57c0,1.11-.1,2.1-.31,2.96-.2.86-.49,1.59-.87,2.18-.38.59-.84,1.04-1.4,1.35-.55.3-1.18.45-1.88.45-.67,0-1.26-.15-1.79-.44-.52-.3-.96-.73-1.32-1.29-.36-.56-.63-1.25-.82-2.07-.19-.82-.28-1.76-.28-2.82,0-1.16.1-2.19.29-3.08.2-.89.49-1.64.86-2.24.38-.61.84-1.06,1.4-1.36.56-.31,1.21-.46,1.93-.46,2.79,0,4.18,2.27,4.18,6.82Zm-1.56.15c0-3.79-.9-5.68-2.7-5.68-1.9,0-2.85,1.93-2.85,5.78,0,3.59.93,5.39,2.79,5.39s2.76-1.83,2.76-5.49Z" />
				<path d="m642.84,235.97v4.15h-1.35v-4.15h1.35Zm3.08,0v4.15h-1.35v-4.15h1.35Z" />
				<path d="m661.13,239.77l-3.19,4.81,3.14,4.69h-1.77l-1.86-3.08c-.12-.19-.26-.43-.42-.72h-.04c-.03.06-.18.3-.44.72l-1.9,3.08h-1.75l3.24-4.66-3.1-4.84h1.77l1.84,3.25c.14.24.27.49.4.74h.04l2.38-3.99h1.68Z" />
				<path d="m673.29,249.27h-1.52v-11.49c-.12.12-.29.25-.52.41-.22.15-.48.3-.76.45-.28.15-.58.29-.89.42-.31.13-.61.23-.91.31v-1.54c.33-.09.69-.22,1.06-.37.38-.16.75-.34,1.1-.53.36-.2.71-.4,1.03-.61.32-.22.6-.43.83-.63h.58v13.6Zm13-6.71c0,1.11-.1,2.1-.31,2.96-.2.86-.49,1.59-.87,2.18-.38.59-.84,1.04-1.4,1.35-.55.3-1.18.45-1.88.45-.67,0-1.26-.15-1.79-.44-.52-.3-.96-.73-1.32-1.29-.36-.56-.63-1.25-.82-2.07-.19-.82-.28-1.76-.28-2.82,0-1.16.1-2.19.29-3.08.2-.89.49-1.64.86-2.24.38-.61.84-1.06,1.4-1.36.56-.31,1.21-.46,1.93-.46,2.79,0,4.18,2.27,4.18,6.82Zm-1.56.15c0-3.79-.9-5.68-2.7-5.68-1.9,0-2.85,1.93-2.85,5.78,0,3.59.93,5.39,2.79,5.39s2.76-1.83,2.76-5.49Z" />
				<rect x="688.6" y="235.97" width="1.35" height="4.15" />
				<path d="m700.38,245.21c0,.65-.11,1.24-.33,1.76-.22.53-.54.98-.96,1.35-.41.38-.9.67-1.48.87-.58.2-1.23.31-1.94.31-1.24,0-2.16-.19-2.76-.56v-1.61c.9.58,1.83.87,2.77.87.48,0,.92-.07,1.3-.21.39-.14.72-.34.99-.59.27-.25.48-.56.62-.92.15-.36.22-.75.22-1.18,0-.87-.29-1.54-.87-2.03-.58-.49-1.43-.74-2.53-.74-.18,0-.37,0-.57,0-.2,0-.4.02-.59.03-.2,0-.39.02-.58.03-.19.01-.36.03-.51.05l.45-6.67h6.15v1.37h-4.83l-.27,3.91c.2-.01.41-.02.63-.03.22-.01.42-.02.59-.02.71,0,1.34.09,1.89.28.56.19,1.03.45,1.41.8.39.34.68.76.88,1.26.2.49.31,1.05.31,1.67Z" />
				<path d="m704.51,235.97v4.15h-1.35v-4.15h1.35Zm3.08,0v4.15h-1.35v-4.15h1.35Z" />
				<path d="m303.32,760.76h-2.98l-7.06-8.36c-.26-.31-.43-.53-.48-.64h-.05v9h-2.14v-18.28h2.14v8.59h.05c.12-.19.28-.4.48-.62l6.83-7.97h2.66l-7.84,8.77,8.39,9.51Zm3.2-16.37c-.37,0-.69-.13-.96-.38-.26-.26-.4-.58-.4-.97s.13-.71.4-.97c.26-.26.58-.4.96-.4s.71.13.97.4c.27.26.41.58.41.97s-.14.69-.41.96c-.26.26-.59.4-.97.4Zm1.02,16.37h-2.09v-13.06h2.09v13.06Zm10.27-.13c-.49.27-1.14.41-1.95.41-2.29,0-3.43-1.27-3.43-3.82v-7.73h-2.24v-1.79h2.24v-3.19l2.09-.68v3.86h3.29v1.79h-3.29v7.36c0,.88.15,1.5.45,1.87s.79.56,1.48.56c.53,0,.98-.14,1.36-.43v1.78Zm11.68-.47c-1,.6-2.19.91-3.57.91-1.86,0-3.37-.6-4.51-1.81-1.14-1.22-1.71-2.79-1.71-4.72,0-2.15.62-3.88,1.85-5.18,1.23-1.31,2.88-1.96,4.93-1.96,1.15,0,2.16.21,3.03.64v2.14c-.97-.68-2.01-1.02-3.11-1.02-1.33,0-2.43.48-3.29,1.44-.85.95-1.27,2.21-1.27,3.76s.4,2.74,1.2,3.62c.81.88,1.89,1.33,3.24,1.33,1.14,0,2.21-.38,3.21-1.13v1.99Zm13.99.6h-2.09v-7.52c0-2.72-1.01-4.08-3.03-4.08-1.02,0-1.88.4-2.58,1.19-.7.78-1.05,1.79-1.05,3.02v7.39h-2.09v-19.33h2.09v8.44h.05c1-1.65,2.43-2.47,4.28-2.47,2.94,0,4.41,1.77,4.41,5.32v8.04Zm14.42-6.01h-9.22c.03,1.45.43,2.58,1.17,3.37.75.79,1.78,1.19,3.09,1.19,1.47,0,2.82-.48,4.05-1.45v1.96c-1.15.83-2.66,1.25-4.55,1.25s-3.29-.59-4.35-1.77c-1.05-1.19-1.58-2.86-1.58-5.01,0-2.03.57-3.68,1.72-4.96,1.16-1.28,2.59-1.93,4.3-1.93s3.03.55,3.97,1.66c.94,1.1,1.4,2.64,1.4,4.6v1.1Zm-2.14-1.77c0-1.21-.3-2.15-.88-2.82-.57-.67-1.36-1.01-2.38-1.01s-1.82.35-2.51,1.06-1.11,1.63-1.27,2.77h7.05Zm16.13,7.78h-2.09v-7.45c0-2.77-1.01-4.16-3.03-4.16-1.05,0-1.91.4-2.6,1.19-.68.78-1.02,1.77-1.02,2.97v7.45h-2.09v-13.06h2.09v2.17h.05c.99-1.65,2.41-2.47,4.28-2.47,1.43,0,2.52.46,3.28,1.39.76.92,1.13,2.25,1.13,3.99v7.98Z" />
				<path d="m757.99,617.66l-3.05,10.8h-1.48l-2.22-7.89c-.1-.34-.15-.7-.17-1.1h-.03c-.03.37-.1.73-.2,1.08l-2.24,7.91h-1.47l-3.16-10.8h1.39l2.3,8.29c.1.35.16.71.18,1.08h.04c.03-.27.1-.63.23-1.08l2.39-8.29h1.21l2.29,8.35c.08.29.14.62.18,1.01h.03c.02-.26.09-.61.2-1.04l2.21-8.32h1.37Z" />
				<polygon points="764.3 617.66 759.11 630.25 757.96 630.25 763.13 617.66 764.3 617.66" />
				<path d="m765.56,628.46v-10.8h2.98c3.81,0,5.71,1.75,5.71,5.26,0,1.67-.53,3.01-1.59,4.02-1.05,1.01-2.47,1.51-4.24,1.51h-2.86Zm1.27-9.66v8.51h1.61c1.42,0,2.52-.38,3.31-1.14.79-.76,1.18-1.83,1.18-3.22,0-2.77-1.47-4.15-4.41-4.15h-1.69Z" />
			</g>
		</g>
	)
}

export default PlanU
